import { moveItemInArray, CdkDrag, CdkDropList, DragDropModule } from '@angular/cdk/drag-drop';
import { DOCUMENT, AsyncPipe, CurrencyPipe, DatePipe, DecimalPipe, NgTemplateOutlet, PercentPipe, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, inject, ElementRef, NgZone, Directive, Component, ChangeDetectionStrategy, ViewEncapsulation, ViewChild, Injector, ViewContainerRef, ChangeDetectorRef, Input, NgModule, Pipe, KeyValueDiffers, EventEmitter, Output, InjectionToken, ANIMATION_MODULE_TYPE, booleanAttribute, ContentChildren } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { MatBadge, MatBadgeModule } from '@angular/material/badge';
import { MatButton, MatIconButton, MatFabButton, MatMiniFabButton, MatButtonModule } from '@angular/material/button';
import { MatCheckbox, MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipListbox, MatChip, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger, MatMenuItem, MatMenuModule } from '@angular/material/menu';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBar, MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortHeader, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatRowDef, MatHeaderRowDef, MatFooterRow, MatTable, MatColumnDef, MatHeaderRow, MatRow, MatFooterRowDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatTableModule } from '@angular/material/table';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { Overlay, OverlayModule } from '@angular/cdk/overlay';
import { MatCommonModule } from '@angular/material/core';
import { CdkFlexTableResizeStrategy, ResizeStrategy, ColumnResizeNotifier, HeaderRowEventDispatcher, ColumnResizeNotifierSource, TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER, ColumnResize, ResizeOverlayHandle, ResizeRef, Resizable } from '@ng-matero/extensions/column-resize';
const _c0 = ["top"];
const _c1 = a0 => ({
  $implicit: a0
});
const _c2 = (a0, a1, a2, a3, a4) => [a0, a1, a2, a3, a4];
function MtxGridCell_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
    i0.ɵɵpipe(1, "cellSummary");
    i0.ɵɵpipe(2, "cellSummary");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("title", ctx_r0._getFormatterTooltip(i0.ɵɵpipeBind2(1, 2, ctx_r0.data, ctx_r0.colDef)))("innerHTML", ctx_r0._getText(i0.ɵɵpipeBind2(2, 5, ctx_r0.data, ctx_r0.colDef)), i0.ɵɵsanitizeHtml);
  }
}
function MtxGridCell_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("title", ctx_r0._getFormatterTooltip(ctx_r0.colDef.formatter(ctx_r0.rowData, ctx_r0.colDef)))("innerHTML", ctx_r0._getText(ctx_r0.colDef.formatter(ctx_r0.rowData, ctx_r0.colDef)), i0.ɵɵsanitizeHtml);
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_0_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 12);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_0_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_0_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementStart(25, "span");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "toObservable");
    i0.ɵɵpipe(28, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 23, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 32, i0.ɵɵpipeBind1(3, 30, i0.ɵɵpipeBind1(2, 28, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 34, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 36, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 38, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 40, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 42, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 44, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 46, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 52, i0.ɵɵpipeBind1(13, 50, i0.ɵɵpipeBind1(12, 48, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 58, i0.ɵɵpipeBind1(16, 56, i0.ɵɵpipeBind1(15, 54, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 60, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 62, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 64, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 66, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 68, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 70, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(76, _c1, btn_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 74, i0.ɵɵpipeBind1(27, 72, btn_r3.text)));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_1_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 14);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_1_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_1_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementStart(25, "span");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "toObservable");
    i0.ɵɵpipe(28, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 23, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 32, i0.ɵɵpipeBind1(3, 30, i0.ɵɵpipeBind1(2, 28, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 34, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 36, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 38, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 40, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 42, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 44, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 46, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 52, i0.ɵɵpipeBind1(13, 50, i0.ɵɵpipeBind1(12, 48, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 58, i0.ɵɵpipeBind1(16, 56, i0.ɵɵpipeBind1(15, 54, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 60, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 62, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 64, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 66, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 68, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 70, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(76, _c1, btn_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 74, i0.ɵɵpipeBind1(27, 72, btn_r3.text)));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_2_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_2_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r6);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_2_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementStart(25, "span");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "toObservable");
    i0.ɵɵpipe(28, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 23, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 32, i0.ɵɵpipeBind1(3, 30, i0.ɵɵpipeBind1(2, 28, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 34, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 36, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 38, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 40, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 42, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 44, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 46, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 52, i0.ɵɵpipeBind1(13, 50, i0.ɵɵpipeBind1(12, 48, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 58, i0.ɵɵpipeBind1(16, 56, i0.ɵɵpipeBind1(15, 54, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 60, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 62, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 64, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 66, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 68, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 70, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(76, _c1, btn_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 74, i0.ɵɵpipeBind1(27, 72, btn_r3.text)));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_3_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 16);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_3_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_3_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 22, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 31, i0.ɵɵpipeBind1(3, 29, i0.ɵɵpipeBind1(2, 27, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 33, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 35, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 37, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 39, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 41, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 43, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 45, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 51, i0.ɵɵpipeBind1(13, 49, i0.ɵɵpipeBind1(12, 47, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 57, i0.ɵɵpipeBind1(16, 55, i0.ɵɵpipeBind1(15, 53, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 59, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 61, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 63, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 65, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 67, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 69, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(71, _c1, btn_r3));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_4_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 17);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_4_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_4_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 22, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 31, i0.ɵɵpipeBind1(3, 29, i0.ɵɵpipeBind1(2, 27, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 33, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 35, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 37, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 39, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 41, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 43, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 45, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 51, i0.ɵɵpipeBind1(13, 49, i0.ɵɵpipeBind1(12, 47, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 57, i0.ɵɵpipeBind1(16, 55, i0.ɵɵpipeBind1(15, 53, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 59, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 61, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 63, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 65, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 67, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 69, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(71, _c1, btn_r3));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_5_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_5_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 22, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 31, i0.ɵɵpipeBind1(3, 29, i0.ɵɵpipeBind1(2, 27, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 33, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 35, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 37, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 39, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 41, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 43, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 45, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 51, i0.ɵɵpipeBind1(13, 49, i0.ɵɵpipeBind1(12, 47, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 57, i0.ɵɵpipeBind1(16, 55, i0.ɵɵpipeBind1(15, 53, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 59, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 61, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 63, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 65, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 67, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 69, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(71, _c1, btn_r3));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_6_mat_icon_24_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵpipe(1, "cellActionDisable");
    i0.ɵɵpipe(2, "cellActionTooltip");
    i0.ɵɵpipe(3, "toObservable");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵpipe(5, "cellActionTooltip");
    i0.ɵɵpipe(6, "cellActionTooltip");
    i0.ɵɵpipe(7, "cellActionTooltip");
    i0.ɵɵpipe(8, "cellActionTooltip");
    i0.ɵɵpipe(9, "cellActionTooltip");
    i0.ɵɵpipe(10, "cellActionTooltip");
    i0.ɵɵpipe(11, "cellActionTooltip");
    i0.ɵɵpipe(12, "cellActionBadge");
    i0.ɵɵpipe(13, "toObservable");
    i0.ɵɵpipe(14, "async");
    i0.ɵɵpipe(15, "cellActionBadge");
    i0.ɵɵpipe(16, "toObservable");
    i0.ɵɵpipe(17, "async");
    i0.ɵɵpipe(18, "cellActionBadge");
    i0.ɵɵpipe(19, "cellActionBadge");
    i0.ɵɵpipe(20, "cellActionBadge");
    i0.ɵɵpipe(21, "cellActionBadge");
    i0.ɵɵpipe(22, "cellActionBadge");
    i0.ɵɵpipe(23, "cellActionBadge");
    i0.ɵɵlistener("click", function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_6_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const btn_r3 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r0._onActionClick($event, btn_r3, ctx_r0.rowData));
    });
    i0.ɵɵtemplate(24, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_6_mat_icon_24_Template, 1, 0, "mat-icon", 13);
    i0.ɵɵelementStart(25, "span");
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "toObservable");
    i0.ɵɵpipe(28, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const btn_r3 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    const iconTpl_r4 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(btn_r3.class);
    i0.ɵɵproperty("color", btn_r3.color || "primary")("disabled", i0.ɵɵpipeBind4(1, 23, btn_r3, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue))("matTooltip", i0.ɵɵpipeBind1(4, 32, i0.ɵɵpipeBind1(3, 30, i0.ɵɵpipeBind1(2, 28, btn_r3).message)))("matTooltipClass", i0.ɵɵpipeBind1(5, 34, btn_r3).class)("matTooltipHideDelay", i0.ɵɵpipeBind1(6, 36, btn_r3).hideDelay)("matTooltipShowDelay", i0.ɵɵpipeBind1(7, 38, btn_r3).showDelay)("matTooltipPosition", i0.ɵɵpipeBind1(8, 40, btn_r3).position || "below")("matTooltipPositionAtOrigin", i0.ɵɵpipeBind1(9, 42, btn_r3).positionAtOrigin)("matTooltipTouchGestures", i0.ɵɵpipeBind1(10, 44, btn_r3).touchGestures || "auto")("matTooltipDisabled", i0.ɵɵpipeBind1(11, 46, btn_r3).disabled)("matBadge", i0.ɵɵpipeBind1(14, 52, i0.ɵɵpipeBind1(13, 50, i0.ɵɵpipeBind1(12, 48, btn_r3).content)))("matBadgeDescription", i0.ɵɵpipeBind1(17, 58, i0.ɵɵpipeBind1(16, 56, i0.ɵɵpipeBind1(15, 54, btn_r3).description)))("matBadgeColor", i0.ɵɵpipeBind1(18, 60, btn_r3).color)("matBadgePosition", i0.ɵɵpipeBind1(19, 62, btn_r3).position || "above after")("matBadgeSize", i0.ɵɵpipeBind1(20, 64, btn_r3).size || "medium")("matBadgeOverlap", i0.ɵɵpipeBind1(21, 66, btn_r3).overlap)("matBadgeDisabled", i0.ɵɵpipeBind1(22, 68, btn_r3).disabled)("matBadgeHidden", i0.ɵɵpipeBind1(23, 70, btn_r3).hidden);
    i0.ɵɵadvance(24);
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r4)("ngTemplateOutletContext", i0.ɵɵpureFunction1(76, _c1, btn_r3));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(28, 74, i0.ɵɵpipeBind1(27, 72, btn_r3.text)));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_0_Template, 29, 78, "button", 5)(1, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_1_Template, 29, 78, "button", 6)(2, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_2_Template, 29, 78, "button", 7)(3, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_3_Template, 25, 73, "button", 8)(4, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_4_Template, 25, 73, "button", 9)(5, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_5_Template, 25, 73, "button", 10)(6, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Case_6_Template, 29, 78, "button", 11);
  }
  if (rf & 2) {
    let tmp_15_0;
    const btn_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵconditional((tmp_15_0 = btn_r3.type) === "raised" ? 0 : tmp_15_0 === "stroked" ? 1 : tmp_15_0 === "flat" ? 2 : tmp_15_0 === "icon" ? 3 : tmp_15_0 === "fab" ? 4 : tmp_15_0 === "mini-fab" ? 5 : 6);
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Conditional_0_Template, 7, 1);
  }
  if (rf & 2) {
    const btn_r3 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵconditional(!btn_r3.iif || btn_r3.iif(ctx_r0.rowData) ? 0 : -1);
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, MtxGridCell_Conditional_1_Conditional_1_Case_0_For_1_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵpipe(2, "cellActions");
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵrepeater(i0.ɵɵpipeBind4(2, 0, ctx_r0.colDef.buttons, ctx_r0.rowData, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-chip-listbox")(1, "mat-chip", 20);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵclassMap("bg-" + ctx_r0.colDef.tag[ctx_r0._value].color);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.colDef.tag[ctx_r0._value].text, " ");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._value, " ");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridCell_Conditional_1_Conditional_1_Case_1_Conditional_0_Template, 3, 3, "mat-chip-listbox")(1, MtxGridCell_Conditional_1_Conditional_1_Case_1_Conditional_1_Template, 1, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r0.colDef.tag && ctx_r0.colDef.tag[ctx_r0._value] ? 0 : 1);
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("href", ctx_r0._value, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0._value);
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 3);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("src", ctx_r0._value, i0.ɵɵsanitizeUrl);
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0._getTooltip(ctx_r0._value));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0._getText(ctx_r0._value));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵpipe(1, "number");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0._getTooltip(i0.ɵɵpipeBind3(1, 2, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.digitsInfo, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._getText(i0.ɵɵpipeBind3(3, 6, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.digitsInfo, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale)), " ");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵpipe(1, "currency");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "currency");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0._getTooltip(i0.ɵɵpipeBindV(1, 2, i0.ɵɵpureFunction5(14, _c2, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.currencyCode, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.display, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.digitsInfo, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale))));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._getText(i0.ɵɵpipeBindV(3, 8, i0.ɵɵpureFunction5(20, _c2, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.currencyCode, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.display, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.digitsInfo, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale))), " ");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵpipe(1, "percent");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "percent");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0._getTooltip(i0.ɵɵpipeBind3(1, 2, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.digitsInfo, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._getText(i0.ɵɵpipeBind3(3, 6, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.digitsInfo, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale)), " ");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵpipe(1, "date");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0._getTooltip(i0.ɵɵpipeBind4(1, 2, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.format, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.timezone, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale)));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0._getText(i0.ɵɵpipeBind4(3, 7, ctx_r0._value, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.format, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.timezone, ctx_r0.colDef.typeParameter == null ? null : ctx_r0.colDef.typeParameter.locale)), " ");
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Case_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("title", ctx_r0._getTooltip(ctx_r0._value));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0._getText(ctx_r0._value));
  }
}
function MtxGridCell_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridCell_Conditional_1_Conditional_1_Case_0_Template, 3, 5)(1, MtxGridCell_Conditional_1_Conditional_1_Case_1_Template, 2, 1)(2, MtxGridCell_Conditional_1_Conditional_1_Case_2_Template, 2, 2, "a", 2)(3, MtxGridCell_Conditional_1_Conditional_1_Case_3_Template, 1, 1, "img", 3)(4, MtxGridCell_Conditional_1_Conditional_1_Case_4_Template, 2, 2, "span", 4)(5, MtxGridCell_Conditional_1_Conditional_1_Case_5_Template, 4, 10, "span", 4)(6, MtxGridCell_Conditional_1_Conditional_1_Case_6_Template, 4, 26, "span", 4)(7, MtxGridCell_Conditional_1_Conditional_1_Case_7_Template, 4, 10, "span", 4)(8, MtxGridCell_Conditional_1_Conditional_1_Case_8_Template, 4, 12, "span", 4)(9, MtxGridCell_Conditional_1_Conditional_1_Case_9_Template, 2, 2, "span", 4);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_3_0 = ctx_r0.colDef.type) === "button" ? 0 : tmp_3_0 === "tag" ? 1 : tmp_3_0 === "link" ? 2 : tmp_3_0 === "image" ? 3 : tmp_3_0 === "boolean" ? 4 : tmp_3_0 === "number" ? 5 : tmp_3_0 === "currency" ? 6 : tmp_3_0 === "percent" ? 7 : tmp_3_0 === "date" ? 8 : 9);
  }
}
function MtxGridCell_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridCell_Conditional_1_Conditional_0_Template, 1, 2, "span", 1)(1, MtxGridCell_Conditional_1_Conditional_1_Template, 10, 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r0.colDef.formatter ? 0 : 1);
  }
}
function MtxGridCell_ng_template_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 21);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const btn_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(btn_r11.icon);
  }
}
function MtxGridCell_ng_template_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 22);
  }
  if (rf & 2) {
    const btn_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("fontIcon", btn_r11.fontIcon);
  }
}
function MtxGridCell_ng_template_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 23);
  }
  if (rf & 2) {
    const btn_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("svgIcon", btn_r11.svgIcon);
  }
}
function MtxGridCell_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridCell_ng_template_2_Conditional_0_Template, 2, 1, "mat-icon", 21)(1, MtxGridCell_ng_template_2_Conditional_1_Template, 1, 1, "mat-icon", 22)(2, MtxGridCell_ng_template_2_Conditional_2_Template, 1, 1, "mat-icon", 23);
  }
  if (rf & 2) {
    const btn_r11 = ctx.$implicit;
    i0.ɵɵconditional(btn_r11.icon ? 0 : btn_r11.fontIcon ? 1 : btn_r11.svgIcon ? 2 : -1);
  }
}
const _forTrack0 = ($index, $item) => $item.field;
function MtxGridColumnMenu_Case_0_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 18);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_0_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function MtxGridColumnMenu_Case_1_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_1_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function MtxGridColumnMenu_Case_2_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 21);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_2_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function MtxGridColumnMenu_Case_3_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 22);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_3_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
  }
}
function MtxGridColumnMenu_Case_4_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 23);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_4_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function MtxGridColumnMenu_Case_5_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 24);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_5_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function MtxGridColumnMenu_Case_6_mat_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon");
  }
}
function MtxGridColumnMenu_Case_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 25);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Case_6_mat_icon_1_Template, 1, 0, "mat-icon", 19);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const iconTpl_r3 = i0.ɵɵreference(8);
    const menu_r4 = i0.ɵɵreference(10);
    i0.ɵɵclassMap(ctx_r1.buttonClass);
    i0.ɵɵproperty("color", ctx_r1.buttonColor)("matMenuTriggerFor", menu_r4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", iconTpl_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.buttonText, " ");
  }
}
function MtxGridColumnMenu_ng_template_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.buttonIcon);
  }
}
function MtxGridColumnMenu_ng_template_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 26);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("fontIcon", ctx_r1.buttonFontIcon);
  }
}
function MtxGridColumnMenu_ng_template_7_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mat-icon", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("svgIcon", ctx_r1.buttonSvgIcon);
  }
}
function MtxGridColumnMenu_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridColumnMenu_ng_template_7_Conditional_0_Template, 2, 1, "mat-icon")(1, MtxGridColumnMenu_ng_template_7_Conditional_1_Template, 1, 1, "mat-icon", 26)(2, MtxGridColumnMenu_ng_template_7_Conditional_2_Template, 1, 1, "mat-icon", 27);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.buttonIcon ? 0 : ctx_r1.buttonFontIcon ? 1 : ctx_r1.buttonSvgIcon ? 2 : -1);
  }
}
function MtxGridColumnMenu_Conditional_12_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MtxGridColumnMenu_Conditional_12_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridColumnMenu_Conditional_12_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
  }
}
function MtxGridColumnMenu_Conditional_12_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.headerText, " ");
  }
}
function MtxGridColumnMenu_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Conditional_12_Conditional_1_Template, 1, 1, null, 28)(2, MtxGridColumnMenu_Conditional_12_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.headerTemplate ? 1 : 2);
  }
}
function MtxGridColumnMenu_Conditional_14_For_2_ng_template_3_Template(rf, ctx) {}
function MtxGridColumnMenu_Conditional_14_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 31);
    i0.ɵɵelement(2, "path", 32);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, MtxGridColumnMenu_Conditional_14_For_2_ng_template_3_Template, 0, 0, "ng-template", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    const checkboxList_r7 = i0.ɵɵreference(18);
    i0.ɵɵproperty("cdkDragDisabled", ctx_r1.selectableChecked === "show" ? !col_r6.show : col_r6.hide);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", checkboxList_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c1, col_r6));
  }
}
function MtxGridColumnMenu_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵlistener("cdkDropListDropped", function MtxGridColumnMenu_Conditional_14_Template_div_cdkDropListDropped_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._handleDroped($event));
    });
    i0.ɵɵrepeaterCreate(1, MtxGridColumnMenu_Conditional_14_For_2_Template, 4, 5, "div", 30, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.columns);
  }
}
function MtxGridColumnMenu_Conditional_15_For_2_ng_template_1_Template(rf, ctx) {}
function MtxGridColumnMenu_Conditional_15_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 34);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Conditional_15_For_2_ng_template_1_Template, 0, 0, "ng-template", 33);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r8 = ctx.$implicit;
    i0.ɵɵnextContext(2);
    const checkboxList_r7 = i0.ɵɵreference(18);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", checkboxList_r7)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c1, col_r8));
  }
}
function MtxGridColumnMenu_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵrepeaterCreate(1, MtxGridColumnMenu_Conditional_15_For_2_Template, 2, 4, "div", 34, _forTrack0);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r1.columns);
  }
}
function MtxGridColumnMenu_Conditional_16_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MtxGridColumnMenu_Conditional_16_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridColumnMenu_Conditional_16_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 28);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
function MtxGridColumnMenu_Conditional_16_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.footerText, " ");
  }
}
function MtxGridColumnMenu_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_Conditional_16_Conditional_1_Template, 1, 1, null, 28)(2, MtxGridColumnMenu_Conditional_16_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footerTemplate ? 1 : 2);
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 38);
    i0.ɵɵelement(1, "path", 42);
    i0.ɵɵelementEnd();
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 39);
    i0.ɵɵelement(1, "path", 43);
    i0.ɵɵelementEnd();
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_0_For_6_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 46);
    i0.ɵɵelement(1, "path", 48);
    i0.ɵɵelementEnd();
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_0_For_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 44);
    i0.ɵɵlistener("click", function MtxGridColumnMenu_ng_template_17_Conditional_0_For_6_Template_button_click_0_listener() {
      const item_r10 = i0.ɵɵrestoreView(_r9).$implicit;
      const col_r11 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._handlePinSelect(col_r11, item_r10.value));
    });
    i0.ɵɵelementStart(1, "span", 45);
    i0.ɵɵtemplate(2, MtxGridColumnMenu_ng_template_17_Conditional_0_For_6_Conditional_2_Template, 2, 0, ":svg:svg", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 47);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "toObservable");
    i0.ɵɵpipe(6, "async");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r10 = ctx.$implicit;
    const col_r11 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(col_r11.pinned == item_r10.value ? 2 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 4, i0.ɵɵpipeBind1(5, 2, item_r10.label)));
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 37);
    i0.ɵɵtemplate(1, MtxGridColumnMenu_ng_template_17_Conditional_0_Conditional_1_Template, 2, 0, ":svg:svg", 38)(2, MtxGridColumnMenu_ng_template_17_Conditional_0_Conditional_2_Template, 2, 0, ":svg:svg", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-menu", 40, 3);
    i0.ɵɵrepeaterCreate(5, MtxGridColumnMenu_ng_template_17_Conditional_0_For_6_Template, 7, 6, "button", 41, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const pinList_r12 = i0.ɵɵreference(4);
    const col_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("matMenuTriggerFor", pinList_r12);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r11.pinned ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!col_r11.pinned ? 2 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.pinOptions);
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 49);
    i0.ɵɵtwoWayListener("ngModelChange", function MtxGridColumnMenu_ng_template_17_Conditional_1_Template_mat_checkbox_ngModelChange_0_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const col_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(col_r11[ctx_r1.selectableChecked], $event) || (col_r11[ctx_r1.selectableChecked] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("change", function MtxGridColumnMenu_ng_template_17_Conditional_1_Template_mat_checkbox_change_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const col_r11 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1._handleChecked(col_r11));
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "toObservable");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵtwoWayProperty("ngModel", col_r11[ctx_r1.selectableChecked]);
    i0.ɵɵproperty("disabled", col_r11.disabled);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 5, i0.ɵɵpipeBind1(2, 3, col_r11.header)));
  }
}
function MtxGridColumnMenu_ng_template_17_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 36);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "toObservable");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r11 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 3, i0.ɵɵpipeBind1(2, 1, col_r11.header)));
  }
}
function MtxGridColumnMenu_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGridColumnMenu_ng_template_17_Conditional_0_Template, 7, 3)(1, MtxGridColumnMenu_ng_template_17_Conditional_1_Template, 4, 7, "mat-checkbox", 35)(2, MtxGridColumnMenu_ng_template_17_Conditional_2_Template, 4, 5, "span", 36);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.pinnable ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.selectable ? 1 : 2);
  }
}
const _c3 = ["tableContainer"];
const _c4 = (a0, a1) => ({
  $implicit: a0,
  colDef: a1
});
const _c5 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  rowData: a1,
  index: a2,
  colDef: a3
});
const _c6 = (a0, a1, a2) => ({
  $implicit: a0,
  colDef: a1,
  data: a2
});
const _c7 = (a0, a1, a2) => ({
  $implicit: a0,
  colData: a1,
  colDef: a2
});
const _c8 = () => ["MtxGridExpansionColumnDef"];
const _c9 = (a0, a1, a2, a3) => ({
  $implicit: a0,
  rowData: a1,
  index: a2,
  expanded: a3
});
function MtxGrid_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "mat-progress-bar", 16);
    i0.ɵɵelementEnd();
  }
}
function MtxGrid_Conditional_1_Conditional_2_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_1_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.toolbarTemplate);
  }
}
function MtxGrid_Conditional_1_Conditional_3_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.toolbarTitle);
  }
}
function MtxGrid_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_1_Conditional_3_Conditional_0_Template, 2, 1, "div", 20);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.toolbarTitle ? 0 : -1);
  }
}
function MtxGrid_Conditional_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mtx-grid-column-menu", 21);
    i0.ɵɵlistener("columnChange", function MtxGrid_Conditional_1_Conditional_5_Template_mtx_grid_column_menu_columnChange_0_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._onColumnChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("columns", ctx_r0.columns)("buttonText", ctx_r0.columnMenuButtonText)("buttonType", ctx_r0.columnMenuButtonType)("buttonColor", ctx_r0.columnMenuButtonColor)("buttonClass", ctx_r0.columnMenuButtonClass)("buttonIcon", ctx_r0.columnMenuButtonIcon)("buttonFontIcon", ctx_r0.columnMenuButtonFontIcon)("buttonSvgIcon", ctx_r0.columnMenuButtonSvgIcon)("selectable", ctx_r0.columnHideable)("selectableChecked", ctx_r0.columnHideableChecked)("sortable", ctx_r0.columnSortable)("pinnable", ctx_r0.columnPinnable)("showHeader", ctx_r0.showColumnMenuHeader)("headerText", ctx_r0.columnMenuHeaderText)("headerTemplate", ctx_r0.columnMenuHeaderTemplate)("showFooter", ctx_r0.showColumnMenuFooter)("footerText", ctx_r0.columnMenuFooterText)("footerTemplate", ctx_r0.columnMenuFooterTemplate)("pinOptions", ctx_r0.columnPinOptions);
  }
}
function MtxGrid_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 17);
    i0.ɵɵtemplate(2, MtxGrid_Conditional_1_Conditional_2_Template, 1, 1, null, 14)(3, MtxGrid_Conditional_1_Conditional_3_Template, 1, 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 18);
    i0.ɵɵtemplate(5, MtxGrid_Conditional_1_Conditional_5_Template, 1, 19, "mtx-grid-column-menu", 19);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r0.toolbarTemplate ? 2 : 3);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r0.showColumnMenuButton ? 5 : -1);
  }
}
function MtxGrid_Conditional_6_Conditional_1_th_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 33);
    i0.ɵɵlistener("change", function MtxGrid_Conditional_6_Conditional_1_th_1_Conditional_1_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView($event ? ctx_r0._toggleMasterCheckbox() : null);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("checked", ctx_r0.rowSelection.hasValue() && ctx_r0._isAllSelected())("indeterminate", ctx_r0.rowSelection.hasValue() && !ctx_r0._isAllSelected());
  }
}
function MtxGrid_Conditional_6_Conditional_1_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 31);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_Conditional_1_th_1_Conditional_1_Template, 1, 2, "mat-checkbox", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.multiSelectable ? 1 : -1);
  }
}
function MtxGrid_Conditional_6_Conditional_1_td_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 36);
    i0.ɵɵlistener("click", function MtxGrid_Conditional_6_Conditional_1_td_2_Conditional_1_Template_mat_checkbox_click_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      return i0.ɵɵresetView($event.stopPropagation());
    })("change", function MtxGrid_Conditional_6_Conditional_1_td_2_Conditional_1_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const row_r6 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView($event ? ctx_r0._toggleNormalCheckbox(row_r6) : null);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const row_r6 = ctx_r6.$implicit;
    const index_r8 = ctx_r6.index;
    const dataIndex_r9 = ctx_r6.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r0.rowSelectionFormatter.disabled && ctx_r0.rowSelectionFormatter.disabled(row_r6, ctx_r0._getIndex(index_r8, dataIndex_r9)))("checked", ctx_r0.rowSelection.isSelected(row_r6));
  }
}
function MtxGrid_Conditional_6_Conditional_1_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_Conditional_1_td_2_Conditional_1_Template, 1, 2, "mat-checkbox", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r6 = ctx.$implicit;
    const index_r8 = ctx.index;
    const dataIndex_r9 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ctx_r0.rowSelectionFormatter.hideCheckbox && ctx_r0.rowSelectionFormatter.hideCheckbox(row_r6, ctx_r0._getIndex(index_r8, dataIndex_r9))) ? 1 : -1);
  }
}
function MtxGrid_Conditional_6_Conditional_1_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 37);
  }
}
function MtxGrid_Conditional_6_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 23);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_Conditional_1_th_1_Template, 2, 1, "th", 28)(2, MtxGrid_Conditional_6_Conditional_1_td_2_Template, 2, 1, "td", 29)(3, MtxGrid_Conditional_6_Conditional_1_td_3_Template, 1, 0, "td", 30);
    i0.ɵɵelementContainerEnd();
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_3_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_th_1_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, col_r10, col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate[col_r10.field])("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, col_r10, col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 45);
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 46);
    i0.ɵɵelement(1, "path", 47);
    i0.ɵɵelementEnd();
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_ng_template_7_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_Conditional_1_Template, 1, 0, "span", 45);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "toObservable");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_Conditional_6_Template, 2, 0, ":svg:svg", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_ng_template_7_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    let tmp_18_0;
    const col_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const headerExtraTplBase_r11 = i0.ɵɵreference(16);
    i0.ɵɵproperty("mat-sort-header", (col_r10.sortProp == null ? null : col_r10.sortProp.id) || col_r10.field)("disabled", !col_r10.sortable)("disableClear", (tmp_18_0 = col_r10.sortProp == null ? null : col_r10.sortProp.disableClear) !== null && tmp_18_0 !== undefined ? tmp_18_0 : ctx_r0.sortDisableClear)("arrowPosition", col_r10.sortProp == null ? null : col_r10.sortProp.arrowPosition)("start", col_r10.sortProp == null ? null : col_r10.sortProp.start);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r10.showExpand ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 12, i0.ɵɵpipeBind1(4, 10, col_r10.header)));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(col_r10.sortable ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headerExtraTplBase_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(14, _c4, ctx_r0.headerExtraTemplate, col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_0_Template, 1, 5, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Conditional_2_Template, 8, 17);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.headerTemplate == null ? null : ctx_r0.headerTemplate[col_r10.field]) ? 0 : 2);
  }
}
function MtxGrid_Conditional_6_For_3_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 41);
    i0.ɵɵpipe(1, "colClass");
    i0.ɵɵelementStart(2, "div", 42);
    i0.ɵɵtemplate(3, MtxGrid_Conditional_6_For_3_th_1_Conditional_3_Template, 1, 5, null, 43);
    i0.ɵɵpipe(4, "isTemplateRef");
    i0.ɵɵtemplate(5, MtxGrid_Conditional_6_For_3_th_1_Conditional_5_Template, 3, 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(1, 15, col_r10));
    i0.ɵɵstyleProp("width", col_r10.width)("min-width", col_r10.width)("left", col_r10.left)("right", col_r10.right);
    i0.ɵɵclassProp("mat-table-sticky-left", col_r10.pinned === "left")("mat-table-sticky-right", col_r10.pinned === "right");
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 17, ctx_r0.headerTemplate) ? 3 : 5);
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_2_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_2_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    const row_r13 = ctx_r13.$implicit;
    const index_r15 = ctx_r13.index;
    const dataIndex_r16 = ctx_r13.dataIndex;
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c5, row_r13, row_r13, ctx_r0._getIndex(index_r15, dataIndex_r16), col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    const row_r13 = ctx_r13.$implicit;
    const index_r15 = ctx_r13.index;
    const dataIndex_r16 = ctx_r13.dataIndex;
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellTemplate[col_r10.field])("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c5, row_r13, row_r13, ctx_r0._getIndex(index_r15, dataIndex_r16), col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(3);
    const row_r13 = ctx_r13.$implicit;
    const index_r15 = ctx_r13.index;
    const dataIndex_r16 = ctx_r13.dataIndex;
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", col_r10.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c5, row_r13, row_r13, ctx_r0._getIndex(index_r15, dataIndex_r16), col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 51);
    i0.ɵɵtwoWayListener("openedChange", function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template_button_openedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const dataIndex_r16 = i0.ɵɵnextContext(4).dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.expansionRowStates[dataIndex_r16].expanded, $event) || (ctx_r0.expansionRowStates[dataIndex_r16].expanded = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("toggleChange", function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template_button_toggleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r18);
      const ctx_r13 = i0.ɵɵnextContext(4);
      const row_r13 = ctx_r13.$implicit;
      const dataIndex_r16 = ctx_r13.dataIndex;
      const col_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._onExpansionChange($event, row_r13, col_r10, dataIndex_r16));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 52);
    i0.ɵɵelement(2, "path", 53);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataIndex_r16 = i0.ɵɵnextContext(4).dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("opened", ctx_r0.expansionRowStates[dataIndex_r16].expanded);
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template, 3, 1, "button", 49);
    i0.ɵɵelementStart(1, "mtx-grid-cell", 50);
    i0.ɵɵlistener("rowDataChange", function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Template_mtx_grid_cell_rowDataChange_1_listener($event) {
      i0.ɵɵrestoreView(_r17);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0._onRowDataChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r13 = i0.ɵɵnextContext(3).$implicit;
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(col_r10.showExpand ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rowData", row_r13)("colDef", col_r10)("placeholder", ctx_r0.emptyValuePlaceholder);
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_Template, 1, 7, null, 43)(1, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Template, 2, 4);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵconditional(col_r10.cellTemplate ? 0 : 1);
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_0_Template, 1, 7, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Conditional_2_Template, 2, 1);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.cellTemplate == null ? null : ctx_r0.cellTemplate[col_r10.field]) ? 0 : 2);
  }
}
function MtxGrid_Conditional_6_For_3_td_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 48);
    i0.ɵɵpipe(1, "colClass");
    i0.ɵɵlistener("cellSelectedChange", function MtxGrid_Conditional_6_For_3_td_2_Template_td_cellSelectedChange_0_listener($event) {
      const row_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const col_r10 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._selectCell($event, row_r13, col_r10));
    });
    i0.ɵɵtemplate(2, MtxGrid_Conditional_6_For_3_td_2_Conditional_2_Template, 1, 7, null, 43);
    i0.ɵɵpipe(3, "isTemplateRef");
    i0.ɵɵtemplate(4, MtxGrid_Conditional_6_For_3_td_2_Conditional_4_Template, 3, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r13 = ctx.$implicit;
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpipeBind4(1, 16, col_r10, row_r13, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue));
    i0.ɵɵstyleProp("width", col_r10.width)("min-width", col_r10.width)("left", col_r10.left)("right", col_r10.right);
    i0.ɵɵclassProp("mat-table-sticky-left", col_r10.pinned === "left")("mat-table-sticky-right", col_r10.pinned === "right");
    i0.ɵɵproperty("cellSelectable", ctx_r0.cellSelectable);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 21, ctx_r0.cellTemplate) ? 2 : 4);
  }
}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 45);
  }
}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_2_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_3_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, col_r10, col_r10, ctx_r0.data));
  }
}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate[col_r10.field])("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7, ctx_r0._getColData(ctx_r0.data, col_r10), ctx_r0._getColData(ctx_r0.data, col_r10), col_r10));
  }
}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mtx-grid-cell", 55);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("summary", true)("data", ctx_r0.data)("colDef", col_r10)("placeholder", ctx_r0.emptyValuePlaceholder);
  }
}
function MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Conditional_0_Template, 1, 6, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Conditional_2_Template, 1, 4, "mtx-grid-cell", 55);
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.summaryTemplate == null ? null : ctx_r0.summaryTemplate[col_r10.field]) ? 0 : 2);
  }
}
function MtxGrid_Conditional_6_For_3_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 54);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_For_3_td_3_Conditional_1_Template, 1, 0, "span", 45)(2, MtxGrid_Conditional_6_For_3_td_3_Conditional_2_Template, 1, 6, null, 43);
    i0.ɵɵpipe(3, "isTemplateRef");
    i0.ɵɵtemplate(4, MtxGrid_Conditional_6_For_3_td_3_Conditional_4_Template, 3, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r10 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", col_r10.width)("min-width", col_r10.width)("left", col_r10.left)("right", col_r10.right);
    i0.ɵɵclassProp("mat-table-sticky-left", col_r10.pinned === "left")("mat-table-sticky-right", col_r10.pinned === "right");
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r10.showExpand ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 14, ctx_r0.summaryTemplate) ? 2 : 4);
  }
}
function MtxGrid_Conditional_6_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 24);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_For_3_th_1_Template, 6, 19, "th", 38)(2, MtxGrid_Conditional_6_For_3_td_2_Template, 5, 23, "td", 39)(3, MtxGrid_Conditional_6_For_3_td_3_Template, 5, 16, "td", 40);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const col_r10 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", col_r10.field)("sticky", col_r10.pinned === "left")("stickyEnd", col_r10.pinned === "right");
  }
}
function MtxGrid_Conditional_6_Conditional_4_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 25);
  }
}
function MtxGrid_Conditional_6_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_Conditional_4_tr_0_Template, 1, 0, "tr", 56);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns)("matHeaderRowDefSticky", true);
  }
}
function MtxGrid_Conditional_6_Conditional_5_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r19 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 58);
    i0.ɵɵpipe(1, "rowClass");
    i0.ɵɵlistener("click", function MtxGrid_Conditional_6_Conditional_5_tr_0_Template_tr_click_0_listener($event) {
      const ctx_r19 = i0.ɵɵrestoreView(_r19);
      const row_r21 = ctx_r19.$implicit;
      const index_r22 = ctx_r19.index;
      const dataIndex_r23 = ctx_r19.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0._selectRow($event, row_r21, ctx_r0._getIndex(index_r22, dataIndex_r23)));
    })("contextmenu", function MtxGrid_Conditional_6_Conditional_5_tr_0_Template_tr_contextmenu_0_listener($event) {
      const ctx_r23 = i0.ɵɵrestoreView(_r19);
      const row_r21 = ctx_r23.$implicit;
      const index_r22 = ctx_r23.index;
      const dataIndex_r23 = ctx_r23.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0._contextmenu($event, row_r21, ctx_r0._getIndex(index_r22, dataIndex_r23)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r21 = ctx.$implicit;
    const index_r22 = ctx.index;
    const dataIndex_r23 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵpipeBind4(1, 4, row_r21, index_r22, dataIndex_r23, ctx_r0.rowClassFormatter));
    i0.ɵɵclassProp("selected", ctx_r0.rowSelection.isSelected(row_r21));
  }
}
function MtxGrid_Conditional_6_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_Conditional_5_tr_0_Template, 2, 9, "tr", 57);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
  }
}
function MtxGrid_Conditional_6_Conditional_6_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 27);
  }
}
function MtxGrid_Conditional_6_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_6_Conditional_6_tr_0_Template, 1, 0, "tr", 59);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matFooterRowDef", ctx_r0.displayedColumns)("matFooterRowDefSticky", true);
  }
}
function MtxGrid_Conditional_6_Conditional_7_td_1_ng_template_3_Template(rf, ctx) {}
function MtxGrid_Conditional_6_Conditional_7_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 63)(1, "div", 64)(2, "div", 65);
    i0.ɵɵtemplate(3, MtxGrid_Conditional_6_Conditional_7_td_1_ng_template_3_Template, 0, 0, "ng-template", 43);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const row_r25 = ctx.$implicit;
    const dataIndex_r26 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("colspan", ctx_r0.displayedColumns.length);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.expansionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c9, row_r25, row_r25, dataIndex_r26, ctx_r0.expansionRowStates[dataIndex_r26].expanded));
  }
}
function MtxGrid_Conditional_6_Conditional_7_tr_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 66);
  }
  if (rf & 2) {
    const dataIndex_r27 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.expansionRowStates[dataIndex_r27].expanded ? "expanded" : "collapsed");
  }
}
function MtxGrid_Conditional_6_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 60);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_Conditional_7_td_1_Template, 4, 8, "td", 61);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(2, MtxGrid_Conditional_6_Conditional_7_tr_2_Template, 1, 2, "tr", 62);
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(1, _c8));
  }
}
function MtxGrid_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 22);
    i0.ɵɵlistener("matSortChange", function MtxGrid_Conditional_6_Template_table_matSortChange_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._onSortChange($event));
    });
    i0.ɵɵtemplate(1, MtxGrid_Conditional_6_Conditional_1_Template, 4, 0, "ng-container", 23);
    i0.ɵɵrepeaterCreate(2, MtxGrid_Conditional_6_For_3_Template, 4, 3, "ng-container", 24, _forTrack0);
    i0.ɵɵtemplate(4, MtxGrid_Conditional_6_Conditional_4_Template, 1, 2, "tr", 25)(5, MtxGrid_Conditional_6_Conditional_5_Template, 1, 1, "tr", 26)(6, MtxGrid_Conditional_6_Conditional_6_Template, 1, 2, "tr", 27)(7, MtxGrid_Conditional_6_Conditional_7_Template, 3, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-table-hover", ctx_r0.rowHover)("mat-table-striped", ctx_r0.rowStriped)("mat-table-expandable", ctx_r0.expandable);
    i0.ɵɵproperty("dataSource", ctx_r0.dataSource)("multiTemplateDataRows", ctx_r0.expandable)("matSortActive", ctx_r0.sortActive)("matSortDirection", ctx_r0.sortDirection)("matSortDisableClear", ctx_r0.sortDisableClear)("matSortDisabled", ctx_r0.sortDisabled)("matSortStart", ctx_r0.sortStart)("trackBy", ctx_r0.trackBy);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.rowSelectable && !ctx_r0.hideRowSelectionCheckbox ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.useContentHeaderRowTemplate ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.useContentRowTemplate ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0._whetherShowSummary ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.expandable ? 7 : -1);
  }
}
function MtxGrid_Conditional_7_Conditional_1_th_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r29 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 33);
    i0.ɵɵlistener("change", function MtxGrid_Conditional_7_Conditional_1_th_1_Conditional_1_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r29);
      const ctx_r0 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView($event ? ctx_r0._toggleMasterCheckbox() : null);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("checked", ctx_r0.rowSelection.hasValue() && ctx_r0._isAllSelected())("indeterminate", ctx_r0.rowSelection.hasValue() && !ctx_r0._isAllSelected());
  }
}
function MtxGrid_Conditional_7_Conditional_1_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 31);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_Conditional_1_th_1_Conditional_1_Template, 1, 2, "mat-checkbox", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.multiSelectable ? 1 : -1);
  }
}
function MtxGrid_Conditional_7_Conditional_1_td_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-checkbox", 36);
    i0.ɵɵlistener("click", function MtxGrid_Conditional_7_Conditional_1_td_2_Conditional_1_Template_mat_checkbox_click_0_listener($event) {
      i0.ɵɵrestoreView(_r30);
      return i0.ɵɵresetView($event.stopPropagation());
    })("change", function MtxGrid_Conditional_7_Conditional_1_td_2_Conditional_1_Template_mat_checkbox_change_0_listener($event) {
      i0.ɵɵrestoreView(_r30);
      const row_r31 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView($event ? ctx_r0._toggleNormalCheckbox(row_r31) : null);
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext();
    const row_r31 = ctx_r31.$implicit;
    const index_r33 = ctx_r31.index;
    const dataIndex_r34 = ctx_r31.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("disabled", ctx_r0.rowSelectionFormatter.disabled && ctx_r0.rowSelectionFormatter.disabled(row_r31, ctx_r0._getIndex(index_r33, dataIndex_r34)))("checked", ctx_r0.rowSelection.isSelected(row_r31));
  }
}
function MtxGrid_Conditional_7_Conditional_1_td_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 34);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_Conditional_1_td_2_Conditional_1_Template, 1, 2, "mat-checkbox", 35);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r31 = ctx.$implicit;
    const index_r33 = ctx.index;
    const dataIndex_r34 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!(ctx_r0.rowSelectionFormatter.hideCheckbox && ctx_r0.rowSelectionFormatter.hideCheckbox(row_r31, ctx_r0._getIndex(index_r33, dataIndex_r34))) ? 1 : -1);
  }
}
function MtxGrid_Conditional_7_Conditional_1_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "td", 37);
  }
}
function MtxGrid_Conditional_7_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 23);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_Conditional_1_th_1_Template, 2, 1, "th", 28)(2, MtxGrid_Conditional_7_Conditional_1_td_2_Template, 2, 1, "td", 29)(3, MtxGrid_Conditional_7_Conditional_1_td_3_Template, 1, 0, "td", 30);
    i0.ɵɵelementContainerEnd();
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_3_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_th_1_Conditional_3_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, col_r35, col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate[col_r35.field])("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, col_r35, col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 45);
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 46);
    i0.ɵɵelement(1, "path", 47);
    i0.ɵɵelementEnd();
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_ng_template_7_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_Conditional_1_Template, 1, 0, "span", 45);
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "toObservable");
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(6, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_Conditional_6_Template, 2, 0, ":svg:svg", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_ng_template_7_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    let tmp_18_0;
    const col_r35 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    const headerExtraTplBase_r11 = i0.ɵɵreference(16);
    i0.ɵɵproperty("mat-sort-header", (col_r35.sortProp == null ? null : col_r35.sortProp.id) || col_r35.field)("disabled", !col_r35.sortable)("disableClear", (tmp_18_0 = col_r35.sortProp == null ? null : col_r35.sortProp.disableClear) !== null && tmp_18_0 !== undefined ? tmp_18_0 : ctx_r0.sortDisableClear)("arrowPosition", col_r35.sortProp == null ? null : col_r35.sortProp.arrowPosition)("start", col_r35.sortProp == null ? null : col_r35.sortProp.start);
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r35.showExpand ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 12, i0.ɵɵpipeBind1(4, 10, col_r35.header)));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(col_r35.sortable ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", headerExtraTplBase_r11)("ngTemplateOutletContext", i0.ɵɵpureFunction2(14, _c4, ctx_r0.headerExtraTemplate, col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_0_Template, 1, 5, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Conditional_2_Template, 8, 17);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.headerTemplate == null ? null : ctx_r0.headerTemplate[col_r35.field]) ? 0 : 2);
  }
}
function MtxGrid_Conditional_7_For_3_th_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 71);
    i0.ɵɵpipe(1, "colClass");
    i0.ɵɵelementStart(2, "div", 42);
    i0.ɵɵtemplate(3, MtxGrid_Conditional_7_For_3_th_1_Conditional_3_Template, 1, 5, null, 43);
    i0.ɵɵpipe(4, "isTemplateRef");
    i0.ɵɵtemplate(5, MtxGrid_Conditional_7_For_3_th_1_Conditional_5_Template, 3, 3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpipeBind1(1, 16, col_r35));
    i0.ɵɵstyleProp("width", col_r35.width)("left", col_r35.left)("right", col_r35.right);
    i0.ɵɵclassProp("mat-table-sticky-left", col_r35.pinned === "left")("mat-table-sticky-right", col_r35.pinned === "right");
    i0.ɵɵproperty("resizable", col_r35.resizable)("matResizableMinWidthPx", col_r35.minWidth)("matResizableMaxWidthPx", col_r35.maxWidth);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(4, 18, ctx_r0.headerTemplate) ? 3 : 5);
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_2_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_2_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext();
    const row_r37 = ctx_r37.$implicit;
    const index_r39 = ctx_r37.index;
    const dataIndex_r40 = ctx_r37.dataIndex;
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c5, row_r37, row_r37, ctx_r0._getIndex(index_r39, dataIndex_r40), col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(2);
    const row_r37 = ctx_r37.$implicit;
    const index_r39 = ctx_r37.index;
    const dataIndex_r40 = ctx_r37.dataIndex;
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.cellTemplate[col_r35.field])("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c5, row_r37, row_r37, ctx_r0._getIndex(index_r39, dataIndex_r40), col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r37 = i0.ɵɵnextContext(3);
    const row_r37 = ctx_r37.$implicit;
    const index_r39 = ctx_r37.index;
    const dataIndex_r40 = ctx_r37.dataIndex;
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", col_r35.cellTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(2, _c5, row_r37, row_r37, ctx_r0._getIndex(index_r39, dataIndex_r40), col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r42 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 51);
    i0.ɵɵtwoWayListener("openedChange", function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template_button_openedChange_0_listener($event) {
      i0.ɵɵrestoreView(_r42);
      const dataIndex_r40 = i0.ɵɵnextContext(4).dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(3);
      i0.ɵɵtwoWayBindingSet(ctx_r0.expansionRowStates[dataIndex_r40].expanded, $event) || (ctx_r0.expansionRowStates[dataIndex_r40].expanded = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("toggleChange", function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template_button_toggleChange_0_listener($event) {
      i0.ɵɵrestoreView(_r42);
      const ctx_r37 = i0.ɵɵnextContext(4);
      const row_r37 = ctx_r37.$implicit;
      const dataIndex_r40 = ctx_r37.dataIndex;
      const col_r35 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._onExpansionChange($event, row_r37, col_r35, dataIndex_r40));
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 52);
    i0.ɵɵelement(2, "path", 53);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const dataIndex_r40 = i0.ɵɵnextContext(4).dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵtwoWayProperty("opened", ctx_r0.expansionRowStates[dataIndex_r40].expanded);
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Conditional_0_Template, 3, 1, "button", 49);
    i0.ɵɵelementStart(1, "mtx-grid-cell", 50);
    i0.ɵɵlistener("rowDataChange", function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Template_mtx_grid_cell_rowDataChange_1_listener($event) {
      i0.ɵɵrestoreView(_r41);
      const ctx_r0 = i0.ɵɵnextContext(6);
      return i0.ɵɵresetView(ctx_r0._onRowDataChange($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r37 = i0.ɵɵnextContext(3).$implicit;
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(col_r35.showExpand ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("rowData", row_r37)("colDef", col_r35)("placeholder", ctx_r0.emptyValuePlaceholder);
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_0_Template, 1, 7, null, 43)(1, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Conditional_1_Template, 2, 4);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵconditional(col_r35.cellTemplate ? 0 : 1);
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_0_Template, 1, 7, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Conditional_2_Template, 2, 1);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.cellTemplate == null ? null : ctx_r0.cellTemplate[col_r35.field]) ? 0 : 2);
  }
}
function MtxGrid_Conditional_7_For_3_td_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 48);
    i0.ɵɵpipe(1, "colClass");
    i0.ɵɵlistener("cellSelectedChange", function MtxGrid_Conditional_7_For_3_td_2_Template_td_cellSelectedChange_0_listener($event) {
      const row_r37 = i0.ɵɵrestoreView(_r36).$implicit;
      const col_r35 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0._selectCell($event, row_r37, col_r35));
    });
    i0.ɵɵtemplate(2, MtxGrid_Conditional_7_For_3_td_2_Conditional_2_Template, 1, 7, null, 43);
    i0.ɵɵpipe(3, "isTemplateRef");
    i0.ɵɵtemplate(4, MtxGrid_Conditional_7_For_3_td_2_Conditional_4_Template, 3, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r37 = ctx.$implicit;
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(i0.ɵɵpipeBind4(1, 14, col_r35, row_r37, ctx_r0.rowChangeRecord, ctx_r0.rowChangeRecord == null ? null : ctx_r0.rowChangeRecord.currentValue));
    i0.ɵɵstyleProp("width", col_r35.width)("left", col_r35.left)("right", col_r35.right);
    i0.ɵɵclassProp("mat-table-sticky-left", col_r35.pinned === "left")("mat-table-sticky-right", col_r35.pinned === "right");
    i0.ɵɵproperty("cellSelectable", ctx_r0.cellSelectable);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 19, ctx_r0.cellTemplate) ? 2 : 4);
  }
}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 45);
  }
}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_2_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_3_Conditional_2_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c6, col_r35, col_r35, ctx_r0.data));
  }
}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.summaryTemplate[col_r35.field])("ngTemplateOutletContext", i0.ɵɵpureFunction3(2, _c7, ctx_r0._getColData(ctx_r0.data, col_r35), ctx_r0._getColData(ctx_r0.data, col_r35), col_r35));
  }
}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "mtx-grid-cell", 55);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("summary", true)("data", ctx_r0.data)("colDef", col_r35)("placeholder", ctx_r0.emptyValuePlaceholder);
  }
}
function MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Conditional_0_Template, 1, 6, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Conditional_2_Template, 1, 4, "mtx-grid-cell", 55);
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx_r0.summaryTemplate == null ? null : ctx_r0.summaryTemplate[col_r35.field]) ? 0 : 2);
  }
}
function MtxGrid_Conditional_7_For_3_td_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 54);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_For_3_td_3_Conditional_1_Template, 1, 0, "span", 45)(2, MtxGrid_Conditional_7_For_3_td_3_Conditional_2_Template, 1, 6, null, 43);
    i0.ɵɵpipe(3, "isTemplateRef");
    i0.ɵɵtemplate(4, MtxGrid_Conditional_7_For_3_td_3_Conditional_4_Template, 3, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const col_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵstyleProp("width", col_r35.width)("left", col_r35.left)("right", col_r35.right);
    i0.ɵɵclassProp("mat-table-sticky-left", col_r35.pinned === "left")("mat-table-sticky-right", col_r35.pinned === "right");
    i0.ɵɵadvance();
    i0.ɵɵconditional(col_r35.showExpand ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(i0.ɵɵpipeBind1(3, 12, ctx_r0.summaryTemplate) ? 2 : 4);
  }
}
function MtxGrid_Conditional_7_For_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 24);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_For_3_th_1_Template, 6, 20, "th", 68)(2, MtxGrid_Conditional_7_For_3_td_2_Template, 5, 21, "td", 69)(3, MtxGrid_Conditional_7_For_3_td_3_Template, 5, 14, "td", 70);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const col_r35 = ctx.$implicit;
    i0.ɵɵproperty("matColumnDef", col_r35.field)("sticky", col_r35.pinned === "left")("stickyEnd", col_r35.pinned === "right");
  }
}
function MtxGrid_Conditional_7_Conditional_4_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 25);
  }
}
function MtxGrid_Conditional_7_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_Conditional_4_tr_0_Template, 1, 0, "tr", 56);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns)("matHeaderRowDefSticky", true);
  }
}
function MtxGrid_Conditional_7_Conditional_5_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr", 58);
    i0.ɵɵpipe(1, "rowClass");
    i0.ɵɵlistener("click", function MtxGrid_Conditional_7_Conditional_5_tr_0_Template_tr_click_0_listener($event) {
      const ctx_r43 = i0.ɵɵrestoreView(_r43);
      const row_r45 = ctx_r43.$implicit;
      const index_r46 = ctx_r43.index;
      const dataIndex_r47 = ctx_r43.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0._selectRow($event, row_r45, ctx_r0._getIndex(index_r46, dataIndex_r47)));
    })("contextmenu", function MtxGrid_Conditional_7_Conditional_5_tr_0_Template_tr_contextmenu_0_listener($event) {
      const ctx_r47 = i0.ɵɵrestoreView(_r43);
      const row_r45 = ctx_r47.$implicit;
      const index_r46 = ctx_r47.index;
      const dataIndex_r47 = ctx_r47.dataIndex;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0._contextmenu($event, row_r45, ctx_r0._getIndex(index_r46, dataIndex_r47)));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const row_r45 = ctx.$implicit;
    const index_r46 = ctx.index;
    const dataIndex_r47 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(i0.ɵɵpipeBind4(1, 4, row_r45, index_r46, dataIndex_r47, ctx_r0.rowClassFormatter));
    i0.ɵɵclassProp("selected", ctx_r0.rowSelection.isSelected(row_r45));
  }
}
function MtxGrid_Conditional_7_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_Conditional_5_tr_0_Template, 2, 9, "tr", 57);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
  }
}
function MtxGrid_Conditional_7_Conditional_6_tr_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 27);
  }
}
function MtxGrid_Conditional_7_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_7_Conditional_6_tr_0_Template, 1, 0, "tr", 59);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("matFooterRowDef", ctx_r0.displayedColumns)("matFooterRowDefSticky", true);
  }
}
function MtxGrid_Conditional_7_Conditional_7_td_1_ng_template_3_Template(rf, ctx) {}
function MtxGrid_Conditional_7_Conditional_7_td_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 63)(1, "div", 64)(2, "div", 65);
    i0.ɵɵtemplate(3, MtxGrid_Conditional_7_Conditional_7_td_1_ng_template_3_Template, 0, 0, "ng-template", 43);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const row_r49 = ctx.$implicit;
    const dataIndex_r50 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵattribute("colspan", ctx_r0.displayedColumns.length);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.expansionTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction4(3, _c9, row_r49, row_r49, dataIndex_r50, ctx_r0.expansionRowStates[dataIndex_r50].expanded));
  }
}
function MtxGrid_Conditional_7_Conditional_7_tr_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tr", 66);
  }
  if (rf & 2) {
    const dataIndex_r51 = ctx.dataIndex;
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.expansionRowStates[dataIndex_r51].expanded ? "expanded" : "collapsed");
  }
}
function MtxGrid_Conditional_7_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0, 60);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_Conditional_7_td_1_Template, 4, 8, "td", 61);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(2, MtxGrid_Conditional_7_Conditional_7_tr_2_Template, 1, 2, "tr", 62);
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("matRowDefColumns", i0.ɵɵpureFunction0(1, _c8));
  }
}
function MtxGrid_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "table", 67);
    i0.ɵɵlistener("matSortChange", function MtxGrid_Conditional_7_Template_table_matSortChange_0_listener($event) {
      i0.ɵɵrestoreView(_r28);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._onSortChange($event));
    });
    i0.ɵɵtemplate(1, MtxGrid_Conditional_7_Conditional_1_Template, 4, 0, "ng-container", 23);
    i0.ɵɵrepeaterCreate(2, MtxGrid_Conditional_7_For_3_Template, 4, 3, "ng-container", 24, _forTrack0);
    i0.ɵɵtemplate(4, MtxGrid_Conditional_7_Conditional_4_Template, 1, 2, "tr", 25)(5, MtxGrid_Conditional_7_Conditional_5_Template, 1, 1, "tr", 26)(6, MtxGrid_Conditional_7_Conditional_6_Template, 1, 2, "tr", 27)(7, MtxGrid_Conditional_7_Conditional_7_Template, 3, 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-table-hover", ctx_r0.rowHover)("mat-table-striped", ctx_r0.rowStriped)("mat-table-expandable", ctx_r0.expandable);
    i0.ɵɵproperty("dataSource", ctx_r0.dataSource)("multiTemplateDataRows", ctx_r0.expandable)("matSortActive", ctx_r0.sortActive)("matSortDirection", ctx_r0.sortDirection)("matSortDisableClear", ctx_r0.sortDisableClear)("matSortDisabled", ctx_r0.sortDisabled)("matSortStart", ctx_r0.sortStart)("trackBy", ctx_r0.trackBy);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.rowSelectable && !ctx_r0.hideRowSelectionCheckbox ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r0.useContentHeaderRowTemplate ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r0.useContentRowTemplate ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0._whetherShowSummary ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.expandable ? 7 : -1);
  }
}
function MtxGrid_Conditional_8_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_8_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.noResultTemplate);
  }
}
function MtxGrid_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.noResultText, " ");
  }
}
function MtxGrid_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_8_Conditional_1_Template, 1, 1, null, 14)(2, MtxGrid_Conditional_8_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.noResultTemplate ? 1 : 2);
  }
}
function MtxGrid_Conditional_9_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_9_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sidebarTemplate);
  }
}
function MtxGrid_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_9_Conditional_1_Template, 1, 1, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.sidebarTemplate ? 1 : -1);
  }
}
function MtxGrid_Conditional_11_Conditional_1_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_11_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_11_Conditional_1_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.statusbarTemplate);
  }
}
function MtxGrid_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵtemplate(1, MtxGrid_Conditional_11_Conditional_1_Template, 1, 1, null, 14);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.statusbarTemplate ? 1 : -1);
  }
}
function MtxGrid_Conditional_13_ng_template_0_Template(rf, ctx) {}
function MtxGrid_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_Conditional_13_ng_template_0_Template, 0, 0, "ng-template", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.paginationTemplate);
  }
}
function MtxGrid_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r52 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-paginator", 72);
    i0.ɵɵlistener("page", function MtxGrid_Conditional_14_Template_mat_paginator_page_0_listener($event) {
      i0.ɵɵrestoreView(_r52);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0._onPage($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("mat-paginator-hidden", !ctx_r0.showPaginator);
    i0.ɵɵproperty("showFirstLastButtons", ctx_r0.showFirstLastButtons)("length", ctx_r0.length)("pageIndex", ctx_r0.pageIndex)("pageSize", ctx_r0.pageSize)("pageSizeOptions", ctx_r0.pageSizeOptions)("hidePageSize", ctx_r0.hidePageSize)("disabled", ctx_r0.pageDisabled);
  }
}
function MtxGrid_ng_template_15_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_ng_template_15_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_ng_template_15_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext();
    const headerExtraTemplate_r54 = ctx_r52.$implicit;
    const col_r55 = ctx_r52.colDef;
    i0.ɵɵproperty("ngTemplateOutlet", headerExtraTemplate_r54)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, col_r55, col_r55));
  }
}
function MtxGrid_ng_template_15_Conditional_2_Conditional_0_ng_template_0_Template(rf, ctx) {}
function MtxGrid_ng_template_15_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_ng_template_15_Conditional_2_Conditional_0_ng_template_0_Template, 0, 0, "ng-template", 43);
  }
  if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(2);
    const headerExtraTemplate_r54 = ctx_r52.$implicit;
    const col_r55 = ctx_r52.colDef;
    i0.ɵɵproperty("ngTemplateOutlet", headerExtraTemplate_r54[col_r55.field])("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c4, col_r55, col_r55));
  }
}
function MtxGrid_ng_template_15_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_ng_template_15_Conditional_2_Conditional_0_Template, 1, 5, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
  }
  if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext();
    const headerExtraTemplate_r54 = ctx_r52.$implicit;
    const col_r55 = ctx_r52.colDef;
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, headerExtraTemplate_r54 == null ? null : headerExtraTemplate_r54[col_r55.field]) ? 0 : -1);
  }
}
function MtxGrid_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MtxGrid_ng_template_15_Conditional_0_Template, 1, 5, null, 43);
    i0.ɵɵpipe(1, "isTemplateRef");
    i0.ɵɵtemplate(2, MtxGrid_ng_template_15_Conditional_2_Template, 2, 3);
  }
  if (rf & 2) {
    const headerExtraTemplate_r54 = ctx.$implicit;
    i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, headerExtraTemplate_r54) ? 0 : 2);
  }
}
export { TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER as MAT_TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER } from '@ng-matero/extensions/column-resize';
import { CdkColumnDef, _COALESCED_STYLE_SCHEDULER } from '@angular/cdk/table';
import { Directionality } from '@angular/cdk/bidi';
import { MtxToObservablePipe, MtxIsTemplateRefPipe, MtxPipesModule } from '@ng-matero/extensions/core';
import { MtxDialog, MtxDialogModule } from '@ng-matero/extensions/dialog';
import { isObservable } from 'rxjs';
import { SelectionModel } from '@angular/cdk/collections';

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Overrides CdkFlexTableResizeStrategy to match mat-column elements.
 */
let MatFlexTableResizeStrategy = /*#__PURE__*/(() => {
  class MatFlexTableResizeStrategy extends CdkFlexTableResizeStrategy {
    getColumnCssClass(cssFriendlyColumnName) {
      return `mat-column-${cssFriendlyColumnName}`;
    }
    /** @nocollapse */
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatFlexTableResizeStrategy_BaseFactory;
        return function MatFlexTableResizeStrategy_Factory(__ngFactoryType__) {
          return (ɵMatFlexTableResizeStrategy_BaseFactory || (ɵMatFlexTableResizeStrategy_BaseFactory = i0.ɵɵgetInheritedFactory(MatFlexTableResizeStrategy)))(__ngFactoryType__ || MatFlexTableResizeStrategy);
        };
      })();
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MatFlexTableResizeStrategy,
        factory: MatFlexTableResizeStrategy.ɵfac
      });
    }
  }
  return MatFlexTableResizeStrategy;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const FLEX_RESIZE_STRATEGY_PROVIDER = {
  provide: ResizeStrategy,
  useClass: MatFlexTableResizeStrategy
};
const PROVIDERS = [ColumnResizeNotifier, HeaderRowEventDispatcher, ColumnResizeNotifierSource];
const TABLE_PROVIDERS = [...PROVIDERS, TABLE_LAYOUT_FIXED_RESIZE_STRATEGY_PROVIDER];
const FLEX_PROVIDERS = [...PROVIDERS, FLEX_RESIZE_STRATEGY_PROVIDER];
const TABLE_HOST_BINDINGS = {
  class: 'mat-column-resize-table'
};
const FLEX_HOST_BINDINGS = {
  class: 'mat-column-resize-flex'
};
class AbstractMatColumnResize extends ColumnResize {
  getTableHeight() {
    const table = this.elementRef.nativeElement;
    const tableParent = table.parentNode;
    const isTableContainer = tableParent.classList.contains('mat-table-container');
    return isTableContainer ? tableParent.offsetHeight : table.offsetHeight;
  }
}

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Explicitly enables column resizing for a table-based mat-table.
 * Individual columns must be annotated specifically.
 */
let MatColumnResize = /*#__PURE__*/(() => {
  class MatColumnResize extends AbstractMatColumnResize {
    constructor() {
      super(...arguments);
      this.columnResizeNotifier = inject(ColumnResizeNotifier);
      this.elementRef = inject(ElementRef);
      this.eventDispatcher = inject(HeaderRowEventDispatcher);
      this.ngZone = inject(NgZone);
      this.notifier = inject(ColumnResizeNotifierSource);
    }
    /** @nocollapse */
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatColumnResize_BaseFactory;
        return function MatColumnResize_Factory(__ngFactoryType__) {
          return (ɵMatColumnResize_BaseFactory || (ɵMatColumnResize_BaseFactory = i0.ɵɵgetInheritedFactory(MatColumnResize)))(__ngFactoryType__ || MatColumnResize);
        };
      })();
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MatColumnResize,
        selectors: [["table", "mat-table", "", "columnResize", ""]],
        hostAttrs: [1, "mat-column-resize-table"],
        features: [i0.ɵɵProvidersFeature([...TABLE_PROVIDERS, {
          provide: ColumnResize,
          useExisting: MatColumnResize
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return MatColumnResize;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Explicitly enables column resizing for a flexbox-based mat-table.
 * Individual columns must be annotated specifically.
 */
let MatColumnResizeFlex = /*#__PURE__*/(() => {
  class MatColumnResizeFlex extends AbstractMatColumnResize {
    constructor() {
      super(...arguments);
      this.columnResizeNotifier = inject(ColumnResizeNotifier);
      this.elementRef = inject(ElementRef);
      this.eventDispatcher = inject(HeaderRowEventDispatcher);
      this.ngZone = inject(NgZone);
      this.notifier = inject(ColumnResizeNotifierSource);
    }
    /** @nocollapse */
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatColumnResizeFlex_BaseFactory;
        return function MatColumnResizeFlex_Factory(__ngFactoryType__) {
          return (ɵMatColumnResizeFlex_BaseFactory || (ɵMatColumnResizeFlex_BaseFactory = i0.ɵɵgetInheritedFactory(MatColumnResizeFlex)))(__ngFactoryType__ || MatColumnResizeFlex);
        };
      })();
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MatColumnResizeFlex,
        selectors: [["mat-table", "columnResize", ""]],
        hostAttrs: [1, "mat-column-resize-flex"],
        features: [i0.ɵɵProvidersFeature([...FLEX_PROVIDERS, {
          provide: ColumnResize,
          useExisting: MatColumnResizeFlex
        }]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return MatColumnResizeFlex;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Component shown over the edge of a resizable column that is responsible
 * for handling column resize mouse events and displaying a vertical line along the column edge.
 */
let MatColumnResizeOverlayHandle = /*#__PURE__*/(() => {
  class MatColumnResizeOverlayHandle extends ResizeOverlayHandle {
    constructor() {
      super(...arguments);
      this.columnDef = inject(CdkColumnDef);
      this.columnResize = inject(ColumnResize);
      this.directionality = inject(Directionality);
      this.elementRef = inject(ElementRef);
      this.eventDispatcher = inject(HeaderRowEventDispatcher);
      this.ngZone = inject(NgZone);
      this.resizeNotifier = inject(ColumnResizeNotifierSource);
      this.resizeRef = inject(ResizeRef);
      this.styleScheduler = inject(_COALESCED_STYLE_SCHEDULER);
      this.document = inject(DOCUMENT);
    }
    updateResizeActive(active) {
      super.updateResizeActive(active);
      const originHeight = this.resizeRef.origin.nativeElement.offsetHeight;
      this.topElement.nativeElement.style.height = `${originHeight}px`;
      this.resizeRef.overlayRef.updateSize({
        height: active ? this.columnResize.getTableHeight() : originHeight
      });
    }
    /** @nocollapse */
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatColumnResizeOverlayHandle_BaseFactory;
        return function MatColumnResizeOverlayHandle_Factory(__ngFactoryType__) {
          return (ɵMatColumnResizeOverlayHandle_BaseFactory || (ɵMatColumnResizeOverlayHandle_BaseFactory = i0.ɵɵgetInheritedFactory(MatColumnResizeOverlayHandle)))(__ngFactoryType__ || MatColumnResizeOverlayHandle);
        };
      })();
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MatColumnResizeOverlayHandle,
        selectors: [["ng-component"]],
        viewQuery: function MatColumnResizeOverlayHandle_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.topElement = _t.first);
          }
        },
        hostAttrs: [1, "mat-column-resize-overlay-thumb"],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 2,
        vars: 0,
        consts: [["top", ""], [1, "mat-column-resize-overlay-thumb-top"]],
        template: function MatColumnResizeOverlayHandle_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 1, 0);
          }
        },
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MatColumnResizeOverlayHandle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class AbstractMatResizable extends Resizable {
  constructor() {
    super(...arguments);
    this.minWidthPxInternal = 32;
  }
  getInlineHandleCssClassName() {
    return 'mat-resizable-handle';
  }
  getOverlayHandleComponentType() {
    return MatColumnResizeOverlayHandle;
  }
}
const RESIZABLE_HOST_BINDINGS = {
  class: 'mat-resizable'
};
const RESIZABLE_INPUTS = ['minWidthPx: matResizableMinWidthPx', 'maxWidthPx: matResizableMaxWidthPx'];

/**
 * Explicitly enables column resizing for a mat-header-cell.
 */
let MatResizable = /*#__PURE__*/(() => {
  class MatResizable extends AbstractMatResizable {
    constructor() {
      super(...arguments);
      this.columnDef = inject(CdkColumnDef);
      this.columnResize = inject(ColumnResize);
      this.directionality = inject(Directionality);
      this.elementRef = inject(ElementRef);
      this.eventDispatcher = inject(HeaderRowEventDispatcher);
      this.injector = inject(Injector);
      this.ngZone = inject(NgZone);
      this.overlay = inject(Overlay);
      this.resizeNotifier = inject(ColumnResizeNotifierSource);
      this.resizeStrategy = inject(ResizeStrategy);
      this.styleScheduler = inject(_COALESCED_STYLE_SCHEDULER);
      this.viewContainerRef = inject(ViewContainerRef);
      this.changeDetectorRef = inject(ChangeDetectorRef);
      this.document = inject(DOCUMENT);
      this.isResizable = true;
    }
    get resizableClass() {
      return this.isResizable ? RESIZABLE_HOST_BINDINGS.class : '';
    }
    get resizable() {
      return this.isResizable;
    }
    set resizable(newValue) {
      this.isResizable = newValue == null || newValue === '' || newValue;
    }
    /** @nocollapse */
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵMatResizable_BaseFactory;
        return function MatResizable_Factory(__ngFactoryType__) {
          return (ɵMatResizable_BaseFactory || (ɵMatResizable_BaseFactory = i0.ɵɵgetInheritedFactory(MatResizable)))(__ngFactoryType__ || MatResizable);
        };
      })();
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MatResizable,
        selectors: [["mat-header-cell", "resizable", ""], ["th", "mat-header-cell", "", "resizable", ""]],
        hostVars: 2,
        hostBindings: function MatResizable_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.resizableClass);
          }
        },
        inputs: {
          minWidthPx: [0, "matResizableMinWidthPx", "minWidthPx"],
          maxWidthPx: [0, "matResizableMaxWidthPx", "maxWidthPx"],
          resizable: "resizable"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return MatResizable;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
const ENTRY_COMMON_COMPONENTS = [MatColumnResizeOverlayHandle];
let MatColumnResizeCommonModule = /*#__PURE__*/(() => {
  class MatColumnResizeCommonModule {
    /** @nocollapse */static {
      this.ɵfac = function MatColumnResizeCommonModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatColumnResizeCommonModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MatColumnResizeCommonModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return MatColumnResizeCommonModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const IMPORTS = [MatCommonModule, OverlayModule, MatColumnResizeCommonModule];
let MatColumnResizeModule = /*#__PURE__*/(() => {
  class MatColumnResizeModule {
    /** @nocollapse */static {
      this.ɵfac = function MatColumnResizeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MatColumnResizeModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MatColumnResizeModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [IMPORTS]
      });
    }
  }
  return MatColumnResizeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridUtils = /*#__PURE__*/(() => {
  class MtxGridUtils {
    constructor() {}
    /**
     * Get cell's value based on the data and column's field (e.g. `a.b.c`)
     * @param rowData Row data
     * @param colDef Column definition
     * @returns
     */
    getCellValue(rowData, colDef) {
      const keyArr = colDef.field ? colDef.field.split('.') : [];
      let tmp = '';
      keyArr.forEach((key, i) => {
        if (i === 0) {
          tmp = rowData[key];
        } else {
          tmp = tmp && tmp[key];
        }
      });
      return tmp;
    }
    /**
     * Get all data of a col
     * @param data All data
     * @param colDef Column definition
     * @returns
     */
    getColData(data, colDef) {
      return data.map(rowData => this.getCellValue(rowData, colDef));
    }
    /**
     * Whether the value is empty (`null`, `undefined`, `''`, `[]`)
     * @param value
     * @returns
     */
    isEmpty(value) {
      return value == null || value.toString() === '';
    }
    /**
     * Whether the value contain HTML
     * @param value
     * @returns
     */
    isContainHTML(value) {
      return /<\/?[a-z][\s\S]*>/i.test(value);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridUtils_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridUtils)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: MtxGridUtils,
        factory: MtxGridUtils.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return MtxGridUtils;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridColClassPipe = /*#__PURE__*/(() => {
  class MtxGridColClassPipe {
    transform(colDef, rowData, rowChangeRecord, currentValue) {
      if (typeof colDef.class === 'string') {
        return colDef.class;
      } else if (typeof colDef.class === 'function') {
        return colDef.class(rowData, colDef);
      }
      return '';
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridColClassPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridColClassPipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "colClass",
        type: MtxGridColClassPipe,
        pure: true
      });
    }
  }
  return MtxGridColClassPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridRowClassPipe = /*#__PURE__*/(() => {
  class MtxGridRowClassPipe {
    transform(rowData, index, dataIndex, rowClassFormatter) {
      const rowIndex = index === undefined ? dataIndex : index;
      const classList = rowIndex % 2 === 1 ? ['mat-row-odd'] : [];
      if (rowClassFormatter) {
        for (const key of Object.keys(rowClassFormatter)) {
          if (rowClassFormatter[key](rowData, rowIndex)) {
            classList.push(key);
          }
        }
      }
      return classList.join(' ');
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridRowClassPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridRowClassPipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "rowClass",
        type: MtxGridRowClassPipe,
        pure: true
      });
    }
  }
  return MtxGridRowClassPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridCellActionsPipe = /*#__PURE__*/(() => {
  class MtxGridCellActionsPipe {
    transform(btns, rowData, rowChangeRecord, currentValue) {
      if (typeof btns === 'function') {
        return btns(rowData);
      } else if (Array.isArray(btns)) {
        return btns;
      }
      return [];
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridCellActionsPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridCellActionsPipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cellActions",
        type: MtxGridCellActionsPipe,
        pure: true
      });
    }
  }
  return MtxGridCellActionsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridCellActionTooltipPipe = /*#__PURE__*/(() => {
  class MtxGridCellActionTooltipPipe {
    transform(btn) {
      if (typeof btn.tooltip === 'string' || isObservable(btn.tooltip)) {
        return {
          message: btn.tooltip
        };
      } else {
        return btn.tooltip || {
          message: ''
        };
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridCellActionTooltipPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridCellActionTooltipPipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cellActionTooltip",
        type: MtxGridCellActionTooltipPipe,
        pure: true
      });
    }
  }
  return MtxGridCellActionTooltipPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridCellActionBadgePipe = /*#__PURE__*/(() => {
  class MtxGridCellActionBadgePipe {
    transform(btn) {
      if (typeof btn.badge === 'number' || typeof btn.badge === 'string' || isObservable(btn.badge)) {
        return {
          content: btn.badge
        };
      } else {
        return btn.badge || {
          content: ''
        };
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridCellActionBadgePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridCellActionBadgePipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cellActionBadge",
        type: MtxGridCellActionBadgePipe,
        pure: true
      });
    }
  }
  return MtxGridCellActionBadgePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridCellActionDisablePipe = /*#__PURE__*/(() => {
  class MtxGridCellActionDisablePipe {
    transform(btn, rowData, rowChangeRecord, currentValue) {
      if (typeof btn.disabled === 'boolean') {
        return btn.disabled;
      } else if (typeof btn.disabled === 'function') {
        return btn.disabled(rowData);
      } else {
        return false;
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridCellActionDisablePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridCellActionDisablePipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cellActionDisable",
        type: MtxGridCellActionDisablePipe,
        pure: true
      });
    }
  }
  return MtxGridCellActionDisablePipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridCellSummaryPipe = /*#__PURE__*/(() => {
  class MtxGridCellSummaryPipe {
    constructor() {
      this.utils = inject(MtxGridUtils);
    }
    transform(data, colDef) {
      if (typeof colDef.summary === 'string') {
        return colDef.summary;
      } else if (typeof colDef.summary === 'function') {
        return colDef.summary(this.utils.getColData(data, colDef), colDef);
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridCellSummaryPipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridCellSummaryPipe)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cellSummary",
        type: MtxGridCellSummaryPipe,
        pure: true
      });
    }
  }
  return MtxGridCellSummaryPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridCell = /*#__PURE__*/(() => {
  class MtxGridCell {
    constructor() {
      this._dialog = inject(MtxDialog);
      this._utils = inject(MtxGridUtils);
      this._differs = inject(KeyValueDiffers);
      this._changeDetectorRef = inject(ChangeDetectorRef);
      /** Row data */
      this.rowData = {};
      /** Table data */
      this.data = [];
      /** Whether show summary */
      this.summary = false;
      /** Placeholder for the empty value (`null`, `''`, `[]`) */
      this.placeholder = '--';
      this.rowDataChange = new EventEmitter();
    }
    get _value() {
      return this._utils.getCellValue(this.rowData, this.colDef);
    }
    ngOnInit() {
      this.rowDataDiffer = this._differs.find(this.rowData).create();
    }
    ngDoCheck() {
      const changes = this.rowDataDiffer?.diff(this.rowData);
      if (changes) {
        this._applyChanges(changes);
      }
    }
    _applyChanges(changes) {
      changes.forEachChangedItem(record => {
        this.rowChangeRecord = record;
        this.rowDataChange.emit(record);
        this._changeDetectorRef.markForCheck();
      });
    }
    _getText(value) {
      return value === undefined ? '' : this._utils.isEmpty(value) ? this.placeholder : value;
    }
    _getTooltip(value) {
      return this._utils.isEmpty(value) ? '' : value;
    }
    _getFormatterTooltip(value) {
      return this._utils.isContainHTML(value) || this._utils.isEmpty(value) ? '' : value;
    }
    _onActionClick(event, btn, rowData) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof btn.pop === 'string' || isObservable(btn.pop)) {
        this._dialog.open({
          title: btn.pop,
          buttons: [{
            color: 'primary',
            text: 'OK',
            onClick: () => btn.click?.(rowData) || {}
          }, {
            text: 'CLOSE'
          }]
        });
      } else if (typeof btn.pop === 'object') {
        this._dialog.open({
          title: btn.pop?.title,
          description: btn.pop?.description,
          buttons: [{
            color: btn.pop?.okColor || 'primary',
            text: btn.pop?.okText || 'OK',
            onClick: () => btn.click?.(rowData) || {}
          }, {
            color: btn.pop?.closeColor,
            text: btn.pop?.closeText || 'CLOSE'
          }]
        });
      } else {
        btn.click?.(rowData);
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridCell_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridCell)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MtxGridCell,
        selectors: [["mtx-grid-cell"]],
        inputs: {
          rowData: "rowData",
          colDef: "colDef",
          data: "data",
          summary: "summary",
          placeholder: "placeholder"
        },
        outputs: {
          rowDataChange: "rowDataChange"
        },
        exportAs: ["mtxGridCell"],
        decls: 4,
        vars: 1,
        consts: [["iconTpl", ""], [3, "title", "innerHTML"], ["target", "_blank", 3, "href"], ["alt", "", 1, "mtx-grid-img", 3, "src"], [3, "title"], ["mat-raised-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-stroked-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-flat-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-icon-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-fab", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-mini-fab", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "color", "class", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-raised-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["mat-stroked-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-flat-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-icon-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-fab", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-mini-fab", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["mat-button", "", "type", "button", 1, "mtx-grid-action-button", 3, "click", "color", "disabled", "matTooltip", "matTooltipClass", "matTooltipHideDelay", "matTooltipShowDelay", "matTooltipPosition", "matTooltipPositionAtOrigin", "matTooltipTouchGestures", "matTooltipDisabled", "matBadge", "matBadgeDescription", "matBadgeColor", "matBadgePosition", "matBadgeSize", "matBadgeOverlap", "matBadgeDisabled", "matBadgeHidden"], ["color", "primary"], [1, "mtx-grid-icon"], [1, "mtx-grid-icon", 3, "fontIcon"], [1, "mtx-grid-icon", 3, "svgIcon"]],
        template: function MtxGridCell_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MtxGridCell_Conditional_0_Template, 3, 8, "span", 1)(1, MtxGridCell_Conditional_1_Template, 2, 1)(2, MtxGridCell_ng_template_2_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.summary ? 0 : 1);
          }
        },
        dependencies: [AsyncPipe, CurrencyPipe, DatePipe, DecimalPipe, NgTemplateOutlet, PercentPipe, MatButton, MatIconButton, MatFabButton, MatMiniFabButton, MatIcon, MatChipListbox, MatChip, MatTooltip, MatBadge, MtxToObservablePipe, MtxGridCellActionsPipe, MtxGridCellSummaryPipe, MtxGridCellActionDisablePipe, MtxGridCellActionTooltipPipe, MtxGridCellActionBadgePipe],
        styles: [".mtx-grid-img{display:inline-block;width:32px;border-radius:4px;vertical-align:middle}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MtxGridCell;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridColumnMenu = /*#__PURE__*/(() => {
  class MtxGridColumnMenu {
    constructor() {
      this.columns = [];
      this.selectable = true;
      this.selectableChecked = 'show';
      this.sortable = true;
      this.pinnable = true;
      this._buttonText = '';
      this.buttonType = 'stroked';
      this.buttonClass = '';
      this.buttonIcon = '';
      this.buttonFontIcon = '';
      this.buttonSvgIcon = '';
      this.showHeader = false;
      this.headerText = 'Columns Header';
      this.showFooter = false;
      this.footerText = 'Columns Footer';
      this.columnChange = new EventEmitter();
      this._pinOptions = [{
        label: 'Pin Left',
        value: 'left'
      }, {
        label: 'Pin Right',
        value: 'right'
      }, {
        label: 'No Pin',
        value: null
      }];
    }
    get buttonText() {
      const defaultText = `Columns ${this.selectableChecked === 'show' ? 'Shown' : 'Hidden'}`;
      return this._buttonText ? this._buttonText : defaultText;
    }
    set buttonText(value) {
      this._buttonText = value;
    }
    get pinOptions() {
      return this._pinOptions;
    }
    set pinOptions(value) {
      if (value.length > 0) {
        this._pinOptions = value;
      }
    }
    _handleDroped(e) {
      moveItemInArray(this.columns, e.previousIndex, e.currentIndex);
      this.columnChange.emit(this.columns);
    }
    _handleChecked(col) {
      if (this.selectableChecked === 'show') {
        col.hide = !col.show;
      } else {
        col.show = !col.hide;
      }
      this.columnChange.emit(this.columns);
    }
    _handlePinSelect(col, val) {
      if (col.pinned != val) {
        col.pinned = val;
        this.columnChange.emit(this.columns);
      }
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridColumnMenu_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridColumnMenu)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MtxGridColumnMenu,
        selectors: [["mtx-grid-column-menu"]],
        viewQuery: function MtxGridColumnMenu_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatMenu, 7);
            i0.ɵɵviewQuery(MatMenuTrigger, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuPanel = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuTrigger = _t.first);
          }
        },
        inputs: {
          columns: "columns",
          selectable: "selectable",
          selectableChecked: "selectableChecked",
          sortable: "sortable",
          pinnable: "pinnable",
          buttonText: "buttonText",
          buttonType: "buttonType",
          buttonColor: "buttonColor",
          buttonClass: "buttonClass",
          buttonIcon: "buttonIcon",
          buttonFontIcon: "buttonFontIcon",
          buttonSvgIcon: "buttonSvgIcon",
          showHeader: "showHeader",
          headerText: "headerText",
          headerTemplate: "headerTemplate",
          showFooter: "showFooter",
          footerText: "footerText",
          footerTemplate: "footerTemplate",
          pinOptions: "pinOptions"
        },
        outputs: {
          columnChange: "columnChange"
        },
        exportAs: ["mtxGridColumnMenu"],
        decls: 19,
        vars: 5,
        consts: [["iconTpl", ""], ["menu", "matMenu"], ["checkboxList", ""], ["pinList", "matMenu"], ["mat-raised-button", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], ["mat-stroked-button", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], ["mat-flat-button", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], ["mat-icon-button", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], ["mat-fab", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], ["mat-mini-fab", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], ["mat-button", "", "type", "button", 3, "class", "color", "matMenuTriggerFor"], [1, "mtx-grid-column-menu"], [1, "mtx-grid-column-menu-content", 3, "click", "keydown"], [1, "mtx-grid-column-menu-header"], [1, "mtx-grid-column-menu-body"], ["cdkDropList", "", 1, "mtx-grid-column-menu-list"], [1, "mtx-grid-column-menu-list"], [1, "mtx-grid-column-menu-footer"], ["mat-raised-button", "", "type", "button", 3, "color", "matMenuTriggerFor"], [4, "ngTemplateOutlet"], ["mat-stroked-button", "", "type", "button", 3, "color", "matMenuTriggerFor"], ["mat-flat-button", "", "type", "button", 3, "color", "matMenuTriggerFor"], ["mat-icon-button", "", "type", "button", 3, "color", "matMenuTriggerFor"], ["mat-fab", "", "type", "button", 3, "color", "matMenuTriggerFor"], ["mat-mini-fab", "", "type", "button", 3, "color", "matMenuTriggerFor"], ["mat-button", "", "type", "button", 3, "color", "matMenuTriggerFor"], [3, "fontIcon"], [3, "svgIcon"], [3, "ngTemplateOutlet"], ["cdkDropList", "", 1, "mtx-grid-column-menu-list", 3, "cdkDropListDropped"], ["cdkDrag", "", 1, "mtx-grid-column-menu-item", 3, "cdkDragDisabled"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mtx-grid-icon", "mtx-grid-column-drag-handle-icon"], ["d", "M7,19V17H9V19H7M11,19V17H13V19H11M15,19V17H17V19H15M7,15V13H9V15H7M11,15V13H13V15H11M15,15V13H17V15H15M7,11V9H9V11H7M11,11V9H13V11H11M15,11V9H17V11H15M7,7V5H9V7H7M11,7V5H13V7H11M15,7V5H17V7H15Z"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "mtx-grid-column-menu-item"], [1, "mtx-grid-column-menu-item-label", 3, "ngModel", "disabled"], [1, "mtx-grid-column-menu-item-label"], ["mat-icon-button", "", "type", "button", 1, "mtx-grid-column-pin-button", 3, "matMenuTriggerFor"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mtx-grid-icon", "mtx-grid-column-pin-icon"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mtx-grid-icon", "mtx-grid-column-pin-off-icon"], [1, "mtx-grid-column-pin-list"], ["type", "button", "mat-menu-item", "", 1, "mtx-grid-column-pin-option"], ["d", "M16,12V4H17V2H7V4H8V12L6,14V16H11.2V22H12.8V16H18V14L16,12Z"], ["d", "M2,5.27L3.28,4L20,20.72L18.73,22L12.8,16.07V22H11.2V16H6V14L8,12V11.27L2,5.27M16,12L18,14V16H17.82L8,6.18V4H7V2H17V4H16V12Z"], ["type", "button", "mat-menu-item", "", 1, "mtx-grid-column-pin-option", 3, "click"], [1, "mtx-grid-column-pin-option-placeholder"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mtx-grid-icon", "mtx-grid-column-pin-check-icon"], [1, "mtx-grid-column-pin-option-text"], ["d", "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"], [1, "mtx-grid-column-menu-item-label", 3, "ngModelChange", "change", "ngModel", "disabled"]],
        template: function MtxGridColumnMenu_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵtemplate(0, MtxGridColumnMenu_Case_0_Template, 3, 6, "button", 4)(1, MtxGridColumnMenu_Case_1_Template, 3, 6, "button", 5)(2, MtxGridColumnMenu_Case_2_Template, 3, 6, "button", 6)(3, MtxGridColumnMenu_Case_3_Template, 2, 5, "button", 7)(4, MtxGridColumnMenu_Case_4_Template, 3, 6, "button", 8)(5, MtxGridColumnMenu_Case_5_Template, 3, 6, "button", 9)(6, MtxGridColumnMenu_Case_6_Template, 3, 6, "button", 10)(7, MtxGridColumnMenu_ng_template_7_Template, 3, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementStart(9, "mat-menu", 11, 1)(11, "div", 12);
            i0.ɵɵlistener("click", function MtxGridColumnMenu_Template_div_click_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.stopPropagation());
            })("keydown", function MtxGridColumnMenu_Template_div_keydown_11_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.stopPropagation());
            });
            i0.ɵɵtemplate(12, MtxGridColumnMenu_Conditional_12_Template, 3, 1, "div", 13);
            i0.ɵɵelementStart(13, "div", 14);
            i0.ɵɵtemplate(14, MtxGridColumnMenu_Conditional_14_Template, 3, 0, "div", 15)(15, MtxGridColumnMenu_Conditional_15_Template, 3, 0, "div", 16);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(16, MtxGridColumnMenu_Conditional_16_Template, 3, 1, "div", 17);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(17, MtxGridColumnMenu_ng_template_17_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            let tmp_3_0;
            i0.ɵɵconditional((tmp_3_0 = ctx.buttonType) === "raised" ? 0 : tmp_3_0 === "stroked" ? 1 : tmp_3_0 === "flat" ? 2 : tmp_3_0 === "icon" ? 3 : tmp_3_0 === "fab" ? 4 : tmp_3_0 === "mini-fab" ? 5 : 6);
            i0.ɵɵadvance(12);
            i0.ɵɵconditional(ctx.showHeader ? 12 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.sortable ? 14 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.sortable ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showFooter ? 16 : -1);
          }
        },
        dependencies: [AsyncPipe, NgTemplateOutlet, FormsModule, i1.NgControlStatus, i1.NgModel, MatButton, MatIconButton, MatFabButton, MatMiniFabButton, MatIcon, MatMenu, MatMenuTrigger, MatMenuItem, MatCheckbox, CdkDrag, CdkDropList, MtxToObservablePipe],
        styles: [".mtx-grid-column-menu,.mtx-grid-column-pin-list{color:var(--mtx-grid-column-menu-text-color, var(--mat-sys-on-surface-variant))}.mtx-grid-column-menu .mat-mdc-menu-content{padding:0}.mtx-grid-column-menu-body{max-height:65vh;padding:8px 16px;overflow:auto}.mtx-grid-column-menu-header,.mtx-grid-column-menu-footer{position:sticky;z-index:1;padding:8px 16px}.mtx-grid-column-menu-header{top:0;border-bottom:1px solid var(--mtx-grid-column-menu-divider-color, var(--mat-sys-outline-variant))}.mtx-grid-column-menu-footer{bottom:0;border-top:1px solid var(--mtx-grid-column-menu-divider-color, var(--mat-sys-outline-variant))}.mtx-grid-column-menu-list{display:block;max-width:100%}.mtx-grid-column-menu-list.cdk-drop-list-dragging .mtx-grid-column-menu-item:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.mtx-grid-column-menu-item{display:flex;flex-direction:row;align-items:center}.mtx-grid-column-menu-item.cdk-drag-disabled .cdk-drag-handle{opacity:.35;cursor:no-drop}.mtx-grid-column-menu-item .cdk-drag-handle{cursor:move}.mtx-grid-column-menu-item.cdk-drag-preview{border-radius:4px;box-shadow:0 0 0 1px var(--mtx-grid-outline-color, var(--mat-sys-outline-variant))}.mtx-grid-column-menu-item.cdk-drag-placeholder{opacity:0}.mtx-grid-column-menu-item.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.mtx-grid-column-pin-button.mat-mdc-icon-button .mat-mdc-button-touch-target{width:100%;height:100%}.mtx-grid-column-pin-option.mat-menu-item{display:flex;align-items:center;height:32px}.mtx-grid-column-pin-option-placeholder{display:inline-block;width:20px;height:20px;line-height:20px;vertical-align:middle}.mtx-grid-column-pin-option-text{padding:0 8px;vertical-align:middle}.mtx-grid-column-drag-handle-icon:hover{cursor:move}.mtx-grid-column-menu-item-label.mat-mdc-checkbox .mat-mdc-checkbox-touch-target{width:100%;height:100%}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MtxGridColumnMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridExpansionToggle = /*#__PURE__*/(() => {
  class MtxGridExpansionToggle {
    constructor() {
      this._opened = false;
      this.openedChange = new EventEmitter();
      this.toggleChange = new EventEmitter();
    }
    get opened() {
      return this._opened;
    }
    set opened(newValue) {
      this._opened = newValue;
      this.openedChange.emit(newValue);
    }
    set expandableRow(value) {
      if (value !== this._row) {
        this._row = value;
      }
    }
    set template(value) {
      if (value !== this._tplRef) {
        this._tplRef = value;
      }
    }
    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.toggle();
    }
    toggle() {
      this.opened = !this.opened;
      this.toggleChange.emit(this);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridExpansionToggle_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridExpansionToggle)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxGridExpansionToggle,
        selectors: [["", "mtx-grid-expansion-toggle", ""]],
        hostVars: 2,
        hostBindings: function MtxGridExpansionToggle_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function MtxGridExpansionToggle_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("expanded", ctx.opened);
          }
        },
        inputs: {
          opened: "opened",
          expandableRow: "expandableRow",
          template: [0, "expansionRowTpl", "template"]
        },
        outputs: {
          openedChange: "openedChange",
          toggleChange: "toggleChange"
        }
      });
    }
  }
  return MtxGridExpansionToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridSelectableCell = /*#__PURE__*/(() => {
  class MtxGridSelectableCell {
    constructor() {
      this.ctrlKeyPressed = false;
      this.shiftKeyPressed = false;
      this._selected = false;
      this.cellSelectable = true;
      this.cellSelectedChange = new EventEmitter();
    }
    get selected() {
      return this._selected;
    }
    onClick(event) {
      this.ctrlKeyPressed = event.ctrlKey;
      this.shiftKeyPressed = event.shiftKey;
      if (this.cellSelectable) {
        this.select();
      }
    }
    select() {
      this._selected = true;
      this.cellSelectedChange.emit(this);
    }
    deselect() {
      this._selected = false;
      this.cellSelectedChange.emit(this);
    }
    toggle() {
      this._selected = !this._selected;
      this.cellSelectedChange.emit(this);
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGridSelectableCell_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridSelectableCell)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MtxGridSelectableCell,
        selectors: [["", "mtx-grid-selectable-cell", ""]],
        hostVars: 2,
        hostBindings: function MtxGridSelectableCell_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function MtxGridSelectableCell_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
          if (rf & 2) {
            i0.ɵɵclassProp("selected", ctx.selected);
          }
        },
        inputs: {
          cellSelectable: "cellSelectable"
        },
        outputs: {
          cellSelectedChange: "cellSelectedChange"
        }
      });
    }
  }
  return MtxGridSelectableCell;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/** Injection token that can be used to specify default grid options. */
const MTX_GRID_DEFAULT_OPTIONS = new InjectionToken('mtx-grid-default-options');
let MtxGrid = /*#__PURE__*/(() => {
  class MtxGrid {
    constructor() {
      this._animationsDisabled = inject(ANIMATION_MODULE_TYPE, {
        optional: true
      }) === 'NoopAnimations';
      this._utils = inject(MtxGridUtils);
      this._changeDetectorRef = inject(ChangeDetectorRef);
      this._defaultOptions = inject(MTX_GRID_DEFAULT_OPTIONS, {
        optional: true
      });
      this.dataSource = new MatTableDataSource();
      /** The grid's displayed columns. */
      this.displayedColumns = [];
      /** The grid's columns. */
      this.columns = [];
      /** The grid's data. */
      this.data = [];
      /** The total number of the data. */
      this.length = 0;
      /** Whether the grid is loading. */
      this.loading = false;
      /** Whether the column is resizable. */
      this.columnResizable = this._defaultOptions?.columnResizable ?? false;
      /** Placeholder for the empty value (`null`, `''`, `[]`). */
      this.emptyValuePlaceholder = this._defaultOptions?.emptyValuePlaceholder ?? '--';
      // ===== Page =====
      /** Whether to paginate the data on front end. */
      this.pageOnFront = this._defaultOptions?.pageOnFront ?? true;
      /** Whether to show the paginator. */
      this.showPaginator = this._defaultOptions?.showPaginator ?? true;
      /** Whether the paginator is disabled. */
      this.pageDisabled = this._defaultOptions?.pageDisabled ?? false;
      /** Whether to show the first/last buttons UI to the user. */
      this.showFirstLastButtons = this._defaultOptions?.showFirstLastButtons ?? true;
      /** The zero-based page index of the displayed list of items. */
      this.pageIndex = this._defaultOptions?.pageIndex ?? 0;
      /** Number of items to display on a page. */
      this.pageSize = this._defaultOptions?.pageSize ?? 10;
      /** The set of provided page size options to display to the user. */
      this.pageSizeOptions = this._defaultOptions?.pageSizeOptions ?? [10, 50, 100];
      /** Whether to hide the page size selection UI from the user. */
      this.hidePageSize = this._defaultOptions?.hidePageSize ?? false;
      /** Event emitted when the paginator changes the page size or page index. */
      this.page = new EventEmitter();
      // ===== Sort =====
      /** Whether to sort the data on front end. */
      this.sortOnFront = this._defaultOptions?.sortOnFront ?? true;
      /** The id of the most recently sorted MatSortable. */
      this.sortActive = this._defaultOptions?.sortActive ?? '';
      /** The sort direction of the currently active MatSortable. */
      this.sortDirection = this._defaultOptions?.sortDirection ?? '';
      /**
       * Whether to disable the user from clearing the sort by finishing the sort direction cycle.
       * May be overriden by the column's `disableClear` in `sortProp`.
       */
      this.sortDisableClear = this._defaultOptions?.sortDisableClear ?? false;
      /** Whether the sort is disabled. */
      this.sortDisabled = this._defaultOptions?.sortDisabled ?? false;
      /**
       * The direction to set when an MatSortable is initially sorted.
       * May be overriden by the column's `start` in `sortProp`.
       */
      this.sortStart = this._defaultOptions?.sortStart ?? 'asc';
      /** Event emitted when the user changes either the active sort or sort direction. */
      this.sortChange = new EventEmitter();
      // ===== Row =====
      /** Whether to use the row hover style. */
      this.rowHover = this._defaultOptions?.rowHover ?? false;
      /** Whether to use the row striped style. */
      this.rowStriped = this._defaultOptions?.rowStriped ?? false;
      /** Event emitted when the user clicks the row. */
      this.rowClick = new EventEmitter();
      /** Event emitted when the user attempts to open a context menu. */
      this.rowContextMenu = new EventEmitter();
      // ===== Expandable Row =====
      this.expansionRowStates = [];
      /** Whether the row is expandable. */
      this.expandable = false;
      /** Event emitted when the user toggles the expandable row. */
      this.expansionChange = new EventEmitter();
      // ===== Row Selection =====
      this.rowSelection = new SelectionModel(true, []);
      /** Whether to support multiple row/cell selection. */
      this.multiSelectable = this._defaultOptions?.multiSelectable ?? true;
      /** Whether the user can select multiple rows with click. */
      this.multiSelectionWithClick = this._defaultOptions?.multiSelectionWithClick ?? false;
      /** Whether the row is selectable. */
      this.rowSelectable = this._defaultOptions?.rowSelectable ?? false;
      /** Whether to hide the row selection checkbox. */
      this.hideRowSelectionCheckbox = this._defaultOptions?.hideRowSelectionCheckbox ?? false;
      /** Whether disable rows to be selected when clicked. */
      this.disableRowClickSelection = this._defaultOptions?.disableRowClickSelection ?? false;
      /** The formatter to disable the row selection or hide the row's checkbox. */
      this.rowSelectionFormatter = {};
      /** The selected row items. */
      this.rowSelected = [];
      /** Event emitted when the row is selected. */
      this.rowSelectedChange = new EventEmitter();
      // ===== Cell Selection =====
      this.cellSelection = [];
      /** Whether the cell is selectable. */
      this.cellSelectable = this._defaultOptions?.cellSelectable ?? true;
      /** Event emitted when the cell is selected. */
      this.cellSelectedChange = new EventEmitter();
      // ===== Toolbar =====
      /** Whether to show the toolbar. */
      this.showToolbar = this._defaultOptions?.showToolbar ?? false;
      /** The text of the toolbar's title. */
      this.toolbarTitle = this._defaultOptions?.toolbarTitle ?? '';
      // ===== Column Menu =====
      /** Whether the column is hideable. */
      this.columnHideable = this._defaultOptions?.columnHideable ?? true;
      /** Hide or show when the column's checkbox is checked. */
      this.columnHideableChecked = this._defaultOptions?.columnHideableChecked ?? 'show';
      /** Whether the column is sortable. */
      this.columnSortable = this._defaultOptions?.columnSortable ?? true;
      /** Whether the column is pinnable. */
      this.columnPinnable = this._defaultOptions?.columnPinnable ?? true;
      /** Event emitted when the column is hided or is sorted. */
      this.columnChange = new EventEmitter();
      /** The options for the column pin list. */
      this.columnPinOptions = this._defaultOptions?.columnPinOptions ?? [];
      /** Whether to show the column menu button. */
      this.showColumnMenuButton = this._defaultOptions?.showColumnMenuButton ?? true;
      /** The text for the column menu button. */
      this.columnMenuButtonText = this._defaultOptions?.columnMenuButtonText ?? '';
      /** The type for the column menu button. */
      this.columnMenuButtonType = this._defaultOptions?.columnMenuButtonType ?? 'stroked';
      /** The color for the column menu button. */
      this.columnMenuButtonColor = this._defaultOptions?.columnMenuButtonColor;
      /** The class for the column menu button. */
      this.columnMenuButtonClass = this._defaultOptions?.columnMenuButtonClass ?? '';
      /** The icon for the column menu button. */
      this.columnMenuButtonIcon = this._defaultOptions?.columnMenuButtonIcon ?? '';
      /** The font icon for the column menu button. */
      this.columnMenuButtonFontIcon = this._defaultOptions?.columnMenuButtonFontIcon ?? '';
      /** The svg icon for the column menu button. */
      this.columnMenuButtonSvgIcon = this._defaultOptions?.columnMenuButtonSvgIcon ?? '';
      /** Whether to show the column-menu's header. */
      this.showColumnMenuHeader = this._defaultOptions?.showColumnMenuHeader ?? false;
      /** The text for the column-menu's header. */
      this.columnMenuHeaderText = this._defaultOptions?.columnMenuHeaderText ?? 'Columns Header';
      /** Whether to show the the column-menu's footer. */
      this.showColumnMenuFooter = this._defaultOptions?.showColumnMenuFooter ?? false;
      /** The text for the column-menu's footer. */
      this.columnMenuFooterText = this._defaultOptions?.columnMenuFooterText ?? 'Columns Footer';
      // ===== No Result =====
      /** The displayed text for the empty data. */
      this.noResultText = this._defaultOptions?.noResultText ?? 'No records found';
      // ===== Row Templates =====
      /** Whether to use custom row template. If true, you should define a matRowDef. */
      this.useContentRowTemplate = false;
      // TODO: It can't use together with `useContentRowTemplate`
      this.useContentHeaderRowTemplate = false;
      // TODO: It's not working
      this.useContentFooterRowTemplate = false;
      // ===== Summary =====
      /** Whether to show the summary. */
      this.showSummary = false;
      // ===== Side Bar =====
      /** Whether to show the sidebar. */
      this.showSidebar = false;
      // ===== Status Bar =====
      /** Whether to show the status bar. */
      this.showStatusbar = false;
    }
    get _hasNoResult() {
      return (!this.dataSource.data || this.dataSource.data.length === 0) && !this.loading;
    }
    // TODO: Summary display conditions
    get _whetherShowSummary() {
      return this.showSummary;
    }
    detectChanges() {
      this._changeDetectorRef.detectChanges();
    }
    _getColData(data, colDef) {
      return this._utils.getColData(data, colDef);
    }
    _isColumnHide(item) {
      return item.hide !== undefined ? item.hide : item.show !== undefined ? !item.show : false;
    }
    // Waiting for async data
    ngOnChanges(changes) {
      this._countPinnedPosition();
      this.displayedColumns = this.columns.filter(item => !this._isColumnHide(item)).map(item => item.field);
      if (this.showColumnMenuButton) {
        this.columns.forEach(item => {
          item.hide = this._isColumnHide(item);
          item.show = !item.hide;
        });
      }
      if (this.rowSelectable && !this.hideRowSelectionCheckbox) {
        this.displayedColumns.unshift('MtxGridCheckboxColumnDef');
      }
      // We should copy each item of data for expansion data
      if (this.expandable) {
        this.expansionRowStates = []; // reset
        this.data?.forEach(_ => {
          this.expansionRowStates.push({
            expanded: false
          });
        });
      }
      if (this.rowSelectable) {
        this.rowSelection = new SelectionModel(this.multiSelectable, this.rowSelected);
      }
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.pageOnFront ? this.paginator : null;
      this.dataSource.sort = this.sortOnFront ? this.sort : null;
      // Only scroll top with data change
      if (changes.data) {
        this.scrollTop(0);
      }
    }
    ngAfterViewInit() {
      if (this.pageOnFront) {
        this.dataSource.paginator = this.paginator;
      }
      if (this.sortOnFront) {
        this.dataSource.sort = this.sort;
      }
      if (this.rowDefs?.length > 0 && this.useContentRowTemplate) {
        this.rowDefs.forEach(rowDef => this.table.addRowDef(rowDef));
      }
      if (this.headerRowDefs?.length > 0 && this.useContentHeaderRowTemplate) {
        this.headerRowDefs.forEach(headerRowDef => this.table.addHeaderRowDef(headerRowDef));
      }
      if (this.footerRowDefs?.length > 0 && this.useContentFooterRowTemplate) {
        this.footerRowDefs.forEach(footerRowDef => this.table.addFooterRowDef(footerRowDef));
      }
    }
    ngOnDestroy() {}
    _countPinnedPosition() {
      const count = (acc, cur) => acc + parseFloat(cur.width || '80px');
      const pinnedLeftCols = this.columns.filter(col => col.pinned && col.pinned === 'left');
      pinnedLeftCols.forEach((item, idx) => {
        item.left = pinnedLeftCols.slice(0, idx).reduce(count, 0) + 'px';
      });
      const pinnedRightCols = this.columns.filter(col => col.pinned && col.pinned === 'right').reverse();
      pinnedRightCols.forEach((item, idx) => {
        item.right = pinnedRightCols.slice(0, idx).reduce(count, 0) + 'px';
      });
    }
    _getIndex(index, dataIndex) {
      return index === undefined ? dataIndex : index;
    }
    _onSortChange(sort) {
      this.sortChange.emit(sort);
    }
    _onRowDataChange(record) {
      this.rowChangeRecord = record;
      this._changeDetectorRef.markForCheck();
    }
    /** Expansion change event */
    _onExpansionChange(expansionRef, rowData, column, index) {
      this.expansionChange.emit({
        expanded: expansionRef.opened,
        data: rowData,
        index,
        column
      });
    }
    /** Cell select event */
    _selectCell(cellRef, rowData, colDef) {
      // If not the same cell
      if (this._selectedCell !== cellRef) {
        const colValue = this._utils.getCellValue(rowData, colDef);
        this.cellSelection = []; // reset
        this.cellSelection.push({
          cellData: colValue,
          rowData,
          colDef
        });
        this.cellSelectedChange.emit(this.cellSelection);
        if (this._selectedCell) {
          this._selectedCell.deselect(); // the selectedCell will be undefined
        }
      }
      this._selectedCell = cellRef.selected ? cellRef : undefined;
    }
    /** Row select event */
    _selectRow(event, rowData, index) {
      if (this.rowSelectable && !this.rowSelectionFormatter.disabled?.(rowData, index) && !this.rowSelectionFormatter.hideCheckbox?.(rowData, index) && !this.disableRowClickSelection) {
        // metaKey -> command key
        if (!this.multiSelectionWithClick && !event.ctrlKey && !event.metaKey) {
          this.rowSelection.clear();
        }
        this._toggleNormalCheckbox(rowData);
      }
      this.rowClick.emit({
        event,
        rowData,
        index
      });
    }
    /** Whether the number of selected elements matches the total number of rows. */
    _isAllSelected() {
      const numSelected = this.rowSelection.selected.length;
      const numRows = this.dataSource.data.filter((row, index) => !this.rowSelectionFormatter.disabled?.(row, index)).length;
      return numSelected === numRows;
    }
    /** Select all rows if they are not all selected; otherwise clear selection. */
    _toggleMasterCheckbox() {
      this._isAllSelected() ? this.rowSelection.clear() : this.dataSource.data.forEach((row, index) => {
        if (!this.rowSelectionFormatter.disabled?.(row, index)) {
          this.rowSelection.select(row);
        }
      });
      this.rowSelectedChange.emit(this.rowSelection.selected);
    }
    /** Select normal row */
    _toggleNormalCheckbox(row) {
      this.rowSelection.toggle(row);
      this.rowSelectedChange.emit(this.rowSelection.selected);
    }
    /** Column change event */
    _onColumnChange(columns) {
      this.columnChange.emit(columns);
      this.displayedColumns = Object.assign([], this.getDisplayedColumnFields(columns));
      if (this.rowSelectable && !this.hideRowSelectionCheckbox) {
        this.displayedColumns.unshift('MtxGridCheckboxColumnDef');
      }
    }
    getDisplayedColumnFields(columns) {
      const fields = columns.filter(item => this.columnHideableChecked === 'show' ? item.show : !item.hide).map(item => item.field);
      return fields;
    }
    /** Customize expansion event */
    toggleExpansion(index) {
      if (!this.expandable) {
        throw new Error('The `expandable` should be set true.');
      }
      this.expansionRowStates[index].expanded = !this.expansionRowStates[index].expanded;
      return this.expansionRowStates[index].expanded;
    }
    /** Scroll to top when turn to the next page. */
    _onPage(e) {
      if (this.pageOnFront) {
        this.scrollTop(0);
      }
      this.page.emit(e);
    }
    scrollTop(value) {
      if (value == null) {
        return this.tableContainer?.nativeElement.scrollTop;
      }
      if (this.tableContainer && !this.loading) {
        this.tableContainer.nativeElement.scrollTop = value;
      }
    }
    scrollLeft(value) {
      if (value == null) {
        return this.tableContainer?.nativeElement.scrollLeft;
      }
      if (this.tableContainer && !this.loading) {
        this.tableContainer.nativeElement.scrollLeft = value;
      }
    }
    _contextmenu(event, rowData, index) {
      this.rowContextMenu.emit({
        event,
        rowData,
        index
      });
    }
    /** @nocollapse */
    static {
      this.ɵfac = function MtxGrid_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGrid)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MtxGrid,
        selectors: [["mtx-grid"]],
        contentQueries: function MtxGrid_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MatRowDef, 4);
            i0.ɵɵcontentQuery(dirIndex, MatHeaderRowDef, 4);
            i0.ɵɵcontentQuery(dirIndex, MatFooterRow, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rowDefs = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerRowDefs = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footerRowDefs = _t);
          }
        },
        viewQuery: function MtxGrid_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatTable, 5);
            i0.ɵɵviewQuery(MatPaginator, 5);
            i0.ɵɵviewQuery(MatSort, 5);
            i0.ɵɵviewQuery(ColumnResize, 5);
            i0.ɵɵviewQuery(MtxGridColumnMenu, 5);
            i0.ɵɵviewQuery(_c3, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.table = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.paginator = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnResize = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.columnMenu = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tableContainer = _t.first);
          }
        },
        hostAttrs: [1, "mtx-grid"],
        hostVars: 2,
        hostBindings: function MtxGrid_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("mtx-grid-animations-enabled", !ctx._animationsDisabled);
          }
        },
        inputs: {
          displayedColumns: "displayedColumns",
          columns: "columns",
          data: "data",
          length: "length",
          loading: [2, "loading", "loading", booleanAttribute],
          trackBy: "trackBy",
          columnResizable: [2, "columnResizable", "columnResizable", booleanAttribute],
          emptyValuePlaceholder: "emptyValuePlaceholder",
          pageOnFront: [2, "pageOnFront", "pageOnFront", booleanAttribute],
          showPaginator: [2, "showPaginator", "showPaginator", booleanAttribute],
          pageDisabled: [2, "pageDisabled", "pageDisabled", booleanAttribute],
          showFirstLastButtons: [2, "showFirstLastButtons", "showFirstLastButtons", booleanAttribute],
          pageIndex: "pageIndex",
          pageSize: "pageSize",
          pageSizeOptions: "pageSizeOptions",
          hidePageSize: [2, "hidePageSize", "hidePageSize", booleanAttribute],
          paginationTemplate: "paginationTemplate",
          sortOnFront: [2, "sortOnFront", "sortOnFront", booleanAttribute],
          sortActive: "sortActive",
          sortDirection: "sortDirection",
          sortDisableClear: [2, "sortDisableClear", "sortDisableClear", booleanAttribute],
          sortDisabled: [2, "sortDisabled", "sortDisabled", booleanAttribute],
          sortStart: "sortStart",
          rowHover: [2, "rowHover", "rowHover", booleanAttribute],
          rowStriped: [2, "rowStriped", "rowStriped", booleanAttribute],
          expandable: [2, "expandable", "expandable", booleanAttribute],
          expansionTemplate: "expansionTemplate",
          multiSelectable: [2, "multiSelectable", "multiSelectable", booleanAttribute],
          multiSelectionWithClick: [2, "multiSelectionWithClick", "multiSelectionWithClick", booleanAttribute],
          rowSelectable: [2, "rowSelectable", "rowSelectable", booleanAttribute],
          hideRowSelectionCheckbox: [2, "hideRowSelectionCheckbox", "hideRowSelectionCheckbox", booleanAttribute],
          disableRowClickSelection: [2, "disableRowClickSelection", "disableRowClickSelection", booleanAttribute],
          rowSelectionFormatter: "rowSelectionFormatter",
          rowClassFormatter: "rowClassFormatter",
          rowSelected: "rowSelected",
          cellSelectable: [2, "cellSelectable", "cellSelectable", booleanAttribute],
          showToolbar: [2, "showToolbar", "showToolbar", booleanAttribute],
          toolbarTitle: "toolbarTitle",
          toolbarTemplate: "toolbarTemplate",
          columnHideable: [2, "columnHideable", "columnHideable", booleanAttribute],
          columnHideableChecked: "columnHideableChecked",
          columnSortable: [2, "columnSortable", "columnSortable", booleanAttribute],
          columnPinnable: [2, "columnPinnable", "columnPinnable", booleanAttribute],
          columnPinOptions: "columnPinOptions",
          showColumnMenuButton: [2, "showColumnMenuButton", "showColumnMenuButton", booleanAttribute],
          columnMenuButtonText: "columnMenuButtonText",
          columnMenuButtonType: "columnMenuButtonType",
          columnMenuButtonColor: "columnMenuButtonColor",
          columnMenuButtonClass: "columnMenuButtonClass",
          columnMenuButtonIcon: "columnMenuButtonIcon",
          columnMenuButtonFontIcon: "columnMenuButtonFontIcon",
          columnMenuButtonSvgIcon: "columnMenuButtonSvgIcon",
          showColumnMenuHeader: [2, "showColumnMenuHeader", "showColumnMenuHeader", booleanAttribute],
          columnMenuHeaderText: "columnMenuHeaderText",
          columnMenuHeaderTemplate: "columnMenuHeaderTemplate",
          showColumnMenuFooter: [2, "showColumnMenuFooter", "showColumnMenuFooter", booleanAttribute],
          columnMenuFooterText: "columnMenuFooterText",
          columnMenuFooterTemplate: "columnMenuFooterTemplate",
          noResultText: "noResultText",
          noResultTemplate: "noResultTemplate",
          headerTemplate: "headerTemplate",
          headerExtraTemplate: "headerExtraTemplate",
          cellTemplate: "cellTemplate",
          useContentRowTemplate: [2, "useContentRowTemplate", "useContentRowTemplate", booleanAttribute],
          useContentHeaderRowTemplate: [2, "useContentHeaderRowTemplate", "useContentHeaderRowTemplate", booleanAttribute],
          useContentFooterRowTemplate: [2, "useContentFooterRowTemplate", "useContentFooterRowTemplate", booleanAttribute],
          showSummary: [2, "showSummary", "showSummary", booleanAttribute],
          summaryTemplate: "summaryTemplate",
          showSidebar: [2, "showSidebar", "showSidebar", booleanAttribute],
          sidebarTemplate: "sidebarTemplate",
          showStatusbar: [2, "showStatusbar", "showStatusbar", booleanAttribute],
          statusbarTemplate: "statusbarTemplate"
        },
        outputs: {
          page: "page",
          sortChange: "sortChange",
          rowClick: "rowClick",
          rowContextMenu: "rowContextMenu",
          expansionChange: "expansionChange",
          rowSelectedChange: "rowSelectedChange",
          cellSelectedChange: "cellSelectedChange",
          columnChange: "columnChange"
        },
        exportAs: ["mtxGrid"],
        features: [i0.ɵɵNgOnChangesFeature],
        decls: 17,
        vars: 9,
        consts: [["tableContainer", ""], ["headerExtraTplBase", ""], [1, "mtx-grid-progress"], [1, "mtx-grid-toolbar"], [1, "mtx-grid-main", "mtx-grid-layout"], [1, "mtx-grid-content", "mtx-grid-layout"], [1, "mat-table-container"], ["mat-table", "", "matSort", "", 3, "mat-table-hover", "mat-table-striped", "mat-table-expandable", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy"], ["mat-table", "", "columnResize", "", "matSort", "", 3, "mat-table-hover", "mat-table-striped", "mat-table-expandable", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy"], [1, "mtx-grid-no-result"], [1, "mtx-grid-sidebar"], [1, "mtx-grid-footer"], [1, "mtx-grid-statusbar"], [1, "mtx-grid-pagination"], [3, "ngTemplateOutlet"], [3, "mat-paginator-hidden", "showFirstLastButtons", "length", "pageIndex", "pageSize", "pageSizeOptions", "hidePageSize", "disabled"], ["mode", "indeterminate"], [1, "mtx-grid-toolbar-content"], [1, "mtx-grid-toolbar-actions"], [3, "columns", "buttonText", "buttonType", "buttonColor", "buttonClass", "buttonIcon", "buttonFontIcon", "buttonSvgIcon", "selectable", "selectableChecked", "sortable", "pinnable", "showHeader", "headerText", "headerTemplate", "showFooter", "footerText", "footerTemplate", "pinOptions"], [1, "mtx-grid-toolbar-title"], [3, "columnChange", "columns", "buttonText", "buttonType", "buttonColor", "buttonClass", "buttonIcon", "buttonFontIcon", "buttonSvgIcon", "selectable", "selectableChecked", "sortable", "pinnable", "showHeader", "headerText", "headerTemplate", "showFooter", "footerText", "footerTemplate", "pinOptions"], ["mat-table", "", "matSort", "", 3, "matSortChange", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy"], ["matColumnDef", "MtxGridCheckboxColumnDef"], [3, "matColumnDef", "sticky", "stickyEnd"], ["mat-header-row", ""], ["mat-row", "", 3, "class", "selected"], ["mat-footer-row", ""], ["mat-header-cell", "", "class", "mtx-grid-checkbox-cell", 4, "matHeaderCellDef"], ["mat-cell", "", "class", "mtx-grid-checkbox-cell", 4, "matCellDef"], ["mat-footer-cell", "", "class", "mtx-grid-checkbox-cell", 4, "matFooterCellDef"], ["mat-header-cell", "", 1, "mtx-grid-checkbox-cell"], [3, "checked", "indeterminate"], [3, "change", "checked", "indeterminate"], ["mat-cell", "", 1, "mtx-grid-checkbox-cell"], [3, "disabled", "checked"], [3, "click", "change", "disabled", "checked"], ["mat-footer-cell", "", 1, "mtx-grid-checkbox-cell"], ["mat-header-cell", "", 3, "class", "mat-table-sticky-left", "mat-table-sticky-right", "width", "min-width", "left", "right", 4, "matHeaderCellDef"], ["mat-cell", "", "mtx-grid-selectable-cell", "", 3, "class", "mat-table-sticky-left", "mat-table-sticky-right", "width", "min-width", "left", "right", "cellSelectable", "cellSelectedChange", 4, "matCellDef"], ["mat-footer-cell", "", 3, "mat-table-sticky-left", "mat-table-sticky-right", "width", "min-width", "left", "right", 4, "matFooterCellDef"], ["mat-header-cell", ""], [1, "mat-header-cell-inner"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "mat-sort-header", "disabled", "disableClear", "arrowPosition", "start"], [1, "mtx-grid-expansion-placeholder"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mtx-grid-icon", "mat-sort-header-icon"], ["d", "M3,13H15V11H3M3,6V8H21V6M3,18H9V16H3V18Z"], ["mat-cell", "", "mtx-grid-selectable-cell", "", 3, "cellSelectedChange", "cellSelectable"], ["mat-icon-button", "", "mtx-grid-expansion-toggle", "", "type", "button", 1, "mtx-grid-row-expand-button", 3, "opened"], [3, "rowDataChange", "rowData", "colDef", "placeholder"], ["mat-icon-button", "", "mtx-grid-expansion-toggle", "", "type", "button", 1, "mtx-grid-row-expand-button", 3, "openedChange", "toggleChange", "opened"], ["viewBox", "0 0 24 24", "width", "24px", "height", "24px", "fill", "currentColor", "focusable", "false", 1, "mtx-grid-icon", "mtx-grid-row-expand-icon"], ["d", "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"], ["mat-footer-cell", ""], [3, "summary", "data", "colDef", "placeholder"], ["mat-header-row", "", 4, "matHeaderRowDef", "matHeaderRowDefSticky"], ["mat-row", "", 3, "class", "selected", "click", "contextmenu", 4, "matRowDef", "matRowDefColumns"], ["mat-row", "", 3, "click", "contextmenu"], ["mat-footer-row", "", 4, "matFooterRowDef", "matFooterRowDefSticky"], ["matColumnDef", "MtxGridExpansionColumnDef"], ["mat-cell", "", 4, "matCellDef"], ["mat-row", "", "class", "mtx-grid-expansion", 3, "class", 4, "matRowDef", "matRowDefColumns"], ["mat-cell", ""], [1, "mtx-grid-expansion-detail-wrapper"], [1, "mtx-grid-expansion-detail"], ["mat-row", "", 1, "mtx-grid-expansion"], ["mat-table", "", "columnResize", "", "matSort", "", 3, "matSortChange", "dataSource", "multiTemplateDataRows", "matSortActive", "matSortDirection", "matSortDisableClear", "matSortDisabled", "matSortStart", "trackBy"], ["mat-header-cell", "", 3, "class", "mat-table-sticky-left", "mat-table-sticky-right", "width", "left", "right", "resizable", "matResizableMinWidthPx", "matResizableMaxWidthPx", 4, "matHeaderCellDef"], ["mat-cell", "", "mtx-grid-selectable-cell", "", 3, "class", "mat-table-sticky-left", "mat-table-sticky-right", "width", "left", "right", "cellSelectable", "cellSelectedChange", 4, "matCellDef"], ["mat-footer-cell", "", 3, "mat-table-sticky-left", "mat-table-sticky-right", "width", "left", "right", 4, "matFooterCellDef"], ["mat-header-cell", "", 3, "resizable", "matResizableMinWidthPx", "matResizableMaxWidthPx"], [3, "page", "showFirstLastButtons", "length", "pageIndex", "pageSize", "pageSizeOptions", "hidePageSize", "disabled"]],
        template: function MtxGrid_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MtxGrid_Conditional_0_Template, 2, 0, "div", 2)(1, MtxGrid_Conditional_1_Template, 6, 2, "div", 3);
            i0.ɵɵelementStart(2, "div", 4)(3, "div", 5)(4, "div", 6, 0);
            i0.ɵɵtemplate(6, MtxGrid_Conditional_6_Template, 8, 19, "table", 7)(7, MtxGrid_Conditional_7_Template, 8, 19, "table", 8);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, MtxGrid_Conditional_8_Template, 3, 1, "div", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(9, MtxGrid_Conditional_9_Template, 2, 1, "div", 10);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 11);
            i0.ɵɵtemplate(11, MtxGrid_Conditional_11_Template, 2, 1, "div", 12);
            i0.ɵɵelementStart(12, "div", 13);
            i0.ɵɵtemplate(13, MtxGrid_Conditional_13_Template, 1, 1, null, 14)(14, MtxGrid_Conditional_14_Template, 1, 9, "mat-paginator", 15);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(15, MtxGrid_ng_template_15_Template, 3, 3, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.loading ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showToolbar ? 1 : -1);
            i0.ɵɵadvance(3);
            i0.ɵɵclassProp("mat-table-with-data", !ctx._hasNoResult);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.columnResizable ? 6 : 7);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx._hasNoResult ? 8 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.showSidebar ? 9 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.showStatusbar ? 11 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.paginationTemplate ? 13 : 14);
          }
        },
        dependencies: [AsyncPipe, NgTemplateOutlet, MatProgressBar, MatIconButton, MatCheckbox, MatTable, MatColumnDef, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatFooterRowDef, MatFooterRow, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatFooterCellDef, MatFooterCell, MatSort, MatSortHeader, MatPaginator, MatResizable, MatColumnResize, MtxGridCell, MtxGridColumnMenu, MtxGridSelectableCell, MtxGridExpansionToggle, MtxIsTemplateRefPipe, MtxGridColClassPipe, MtxGridRowClassPipe, MtxToObservablePipe],
        styles: [".mat-column-resize-table.cdk-column-resize-with-resized-column{table-layout:fixed}.mat-column-resize-flex .mat-mdc-header-cell,.mat-column-resize-flex .mat-mdc-cell{box-sizing:border-box;min-width:32px}.mat-mdc-header-cell{position:relative}.mat-resizable{box-sizing:border-box}.mat-mdc-header-cell:not(.mat-resizable):after,.mat-resizable-handle{position:absolute;bottom:0;top:0;right:0;width:1px;background:transparent;transition:background .3s cubic-bezier(.55,0,.55,.2)}.mat-mdc-header-cell:not(.mat-resizable):after{content:\"\"}[dir=rtl] .mat-mdc-header-cell:not(.mat-resizable):after,[dir=rtl] .mat-resizable-handle{left:0;right:auto}[dir=rtl] .mat-mdc-header-row.cdk-column-resize-hover-or-active .mat-header-cell,[dir=rtl] .mat-mdc-header-row.cdk-column-resize-hover-or-active .mat-mdc-header-cell{border-left:none}.mat-mdc-header-row.cdk-column-resize-hover-or-active .mat-mdc-header-cell{border-right:none}.mat-mdc-header-row.cdk-column-resize-hover-or-active .mat-mdc-header-cell:not(.mat-resizable):after{background-color:var(--mtx-grid-resizable-handle-disabled-background-color, var(--mat-sys-outline-variant))}.mat-mdc-header-row.cdk-column-resize-hover-or-active .mat-resizable-handle{background-color:var(--mtx-grid-resizable-handle-hover-background-color, var(--mat-sys-primary))}.mat-resizable.cdk-resizable-overlay-thumb-active>.mat-resizable-handle{opacity:0;transition:none}.mat-resizable-handle:focus,.mat-mdc-header-row.cdk-column-resize-hover-or-active .mat-resizable-handle:focus{outline:none;background-color:var(--mtx-grid-resizable-handle-active-background-color, var(--mat-sys-primary))}.mat-column-resize-overlay-thumb{background:transparent;cursor:col-resize;width:100%;height:100%;transition:background .3s cubic-bezier(.55,0,.55,.2);-webkit-user-select:none;user-select:none}.mat-column-resize-overlay-thumb:active{will-change:transform;background:linear-gradient(90deg,transparent,transparent 7px,var(--mtx-grid-resizable-handle-active-background-color, var(--mat-sys-primary)) 7px,var(--mtx-grid-resizable-handle-active-background-color, var(--mat-sys-primary)) 9px,transparent 9px,transparent)}.mat-column-resize-overlay-thumb:active .mat-column-resize-overlay-thumb-top{background:linear-gradient(90deg,transparent,transparent 4px,var(--mtx-grid-resizable-handle-active-background-color, var(--mat-sys-primary)) 4px,var(--mtx-grid-resizable-handle-active-background-color, var(--mat-sys-primary)) 12px,transparent 12px,transparent)}.mat-column-resize-overlay-thumb-top{width:100%}.mtx-grid{position:relative;display:flex;flex-direction:column;width:100%;overflow:hidden;border:1px solid var(--mtx-grid-outline-color, var(--mat-sys-outline-variant));border-radius:var(--mtx-grid-container-shape, var(--mat-sys-corner-medium))}.mtx-grid .mat-mdc-table{--mat-table-row-item-outline-color: var(--mtx-grid-outline-color, var(--mat-sys-outline-variant))}.mtx-grid .mat-mdc-table.mat-table-striped .mat-row-odd{background-color:var(--mtx-grid-table-row-striped-background-color, var(--mat-sys-surface-container))}.mtx-grid .mat-mdc-table.mat-table-hover .mat-mdc-row:hover{background-color:var(--mtx-grid-table-row-hover-background-color, var(--mat-sys-secondary-container))}.mtx-grid .mat-mdc-table.mat-table-hover .mat-mdc-row.selected:hover{background-color:var(--mtx-grid-table-row-selected-hover-background-color, var(--mat-sys-primary-container))}.mtx-grid .mat-mdc-table .mat-mdc-row.selected{background-color:var(--mtx-grid-table-row-selected-background-color, var(--mat-sys-secondary-container))}.mtx-grid .mat-mdc-table .mat-mdc-cell.selected{box-shadow:inset 0 0 0 1px var(--mtx-grid-table-cell-selected-outline-color, var(--mat-sys-primary))}.mtx-grid .mat-table-container{overflow:auto}.mtx-grid .mat-table-container.mat-table-with-data{flex:1}.mtx-grid .mat-mdc-table:not(.mat-column-resize-table){min-width:100%;border-collapse:separate}.mtx-grid .mat-mdc-table:not(.mat-column-resize-table) .mat-mdc-header-cell:not(.mtx-grid-checkbox-cell),.mtx-grid .mat-mdc-table:not(.mat-column-resize-table) .mat-mdc-footer-cell:not(.mtx-grid-checkbox-cell),.mtx-grid .mat-mdc-table:not(.mat-column-resize-table) .mat-mdc-cell:not(.mtx-grid-checkbox-cell){min-width:var(--mtx-grid-table-cell-min-width, 80px)}.mtx-grid .mat-table-sticky-left{border-right:1px solid var(--mat-table-row-item-outline-color)}[dir=rtl] .mtx-grid .mat-table-sticky-left{border-right-width:0;border-left:1px solid var(--mat-table-row-item-outline-color)}.mtx-grid .mat-table-sticky-right{border-left:1px solid var(--mat-table-row-item-outline-color)}[dir=rtl] .mtx-grid .mat-table-sticky-right{border-left-width:0;border-right:1px solid var(--mat-table-row-item-outline-color)}.mtx-grid .mat-mdc-footer-cell{border-top:1px solid var(--mat-table-row-item-outline-color);background-color:var(--mtx-grid-table-footer-background-color, var(--mat-sys-surface-container))}.mtx-grid .mat-mdc-row.mtx-grid-expansion{height:0;overflow:hidden}.mtx-grid .mat-mdc-row.mtx-grid-expansion .mat-mdc-cell{padding-top:0;padding-bottom:0}.mtx-grid .mat-mdc-row.mtx-grid-expansion.collapsed .mat-mdc-cell{border-bottom-width:0}.mtx-grid .mat-sort-header-icon{margin-left:4px}[dir=rtl] .mtx-grid .mat-sort-header-icon{margin-left:0;margin-right:4px}.mtx-grid .mat-header-cell-inner{display:inline-flex;align-items:center;vertical-align:middle}.mtx-grid .mat-mdc-paginator{border-top:1px solid var(--mtx-grid-outline-color, var(--mat-sys-outline-variant));border-bottom-left-radius:var(--mtx-grid-container-shape, var(--mat-sys-corner-medium));border-bottom-right-radius:var(--mtx-grid-container-shape, var(--mat-sys-corner-medium))}.mtx-grid .mat-paginator-hidden{display:none}.mtx-grid .mtx-grid-checkbox-cell{width:60px;min-width:60px;padding:0 calc((60px - var(--mdc-checkbox-state-layer-size, 40px)) / 2)}.mtx-grid-progress{position:absolute;top:0;z-index:120;width:100%}.mtx-grid-toolbar{display:flex;justify-content:space-between;align-items:center;min-height:var(--mat-table-header-container-height, 56px);padding:8px;box-sizing:border-box;border-bottom:1px solid var(--mtx-grid-outline-color, var(--mat-sys-outline-variant))}.mtx-grid-toolbar-content{flex:1;width:0;padding:0 8px}.mtx-grid-layout{display:flex;flex:1 1 auto;overflow:auto}.mtx-grid-content{flex-direction:column;width:0}.mtx-grid-sidebar{max-width:50%;border-left:1px solid var(--mtx-grid-outline-color, var(--mat-sys-outline-variant))}[dir=rtl] .mtx-grid-sidebar{border-left-width:0;border-right:1px solid var(--mtx-grid-outline-color, var(--mat-sys-outline-variant))}.mtx-grid-footer{position:relative;z-index:1}.mtx-grid-statusbar{display:flex;align-items:center;min-height:var(--mat-table-header-container-height, 56px);padding:8px;box-sizing:border-box;border-top:1px solid var(--mtx-grid-outline-color, var(--mat-sys-outline-variant))}.mtx-grid-no-result{display:flex;justify-content:center;align-items:center;flex:1;min-height:150px}.mtx-grid-expansion-placeholder{display:inline-block;vertical-align:middle;width:var(--mdc-icon-button-state-layer-size, var(--mtx-grid-row-expand-button-size, 40px));height:var(--mdc-icon-button-state-layer-size, var(--mtx-grid-row-expand-button-size, 40px))}.mtx-grid-expansion-detail-wrapper{display:grid;grid-template-rows:0fr;grid-template-columns:100%;padding:0;overflow:hidden}.mtx-grid-expansion.expanded .mtx-grid-expansion-detail-wrapper{grid-template-rows:1fr;padding:calc((var(--mat-table-row-item-container-height, 52px) - 20px) / 2) 0}.mtx-grid-expansion-detail{min-height:0}.mtx-grid-animations-enabled .mtx-grid-expansion-detail-wrapper{transition:all 225ms cubic-bezier(.4,0,.2,1)}.mtx-grid-row-expand-button.expanded .mtx-grid-row-expand-icon{transform:rotate(90deg)}.mtx-grid-row-expand-button.mat-mdc-icon-button,.mtx-grid-row-expand-button+mtx-grid-cell{vertical-align:middle}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return MtxGrid;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MtxGridModule = /*#__PURE__*/(() => {
  class MtxGridModule {
    /** @nocollapse */static {
      this.ɵfac = function MtxGridModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MtxGridModule)();
      };
    }
    /** @nocollapse */
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: MtxGridModule
      });
    }
    /** @nocollapse */
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [MtxGridUtils],
        imports: [CommonModule, FormsModule, MatTableModule, MatSortModule, MatPaginatorModule, MatCheckboxModule, MatButtonModule, MatProgressBarModule, MatChipsModule, MatTooltipModule, MatBadgeModule, MatIconModule, MatSelectModule, MatFormFieldModule, MatMenuModule, DragDropModule, MtxDialogModule, MtxPipesModule, MatColumnResizeModule, MtxGrid, MtxGridCell, MtxGridColumnMenu, MatColumnResizeModule]
      });
    }
  }
  return MtxGridModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AbstractMatColumnResize, AbstractMatResizable, FLEX_HOST_BINDINGS as MAT_FLEX_HOST_BINDINGS, FLEX_PROVIDERS as MAT_FLEX_PROVIDERS, FLEX_RESIZE_STRATEGY_PROVIDER as MAT_FLEX_RESIZE_STRATEGY_PROVIDER, RESIZABLE_HOST_BINDINGS as MAT_RESIZABLE_HOST_BINDINGS, RESIZABLE_INPUTS as MAT_RESIZABLE_INPUTS, TABLE_HOST_BINDINGS as MAT_TABLE_HOST_BINDINGS, TABLE_PROVIDERS as MAT_TABLE_PROVIDERS, MTX_GRID_DEFAULT_OPTIONS, MatColumnResize, MatColumnResizeCommonModule, MatColumnResizeFlex, MatColumnResizeModule, MatColumnResizeOverlayHandle, MatFlexTableResizeStrategy, MatResizable, MtxGrid, MtxGridCell, MtxGridCellActionBadgePipe, MtxGridCellActionDisablePipe, MtxGridCellActionTooltipPipe, MtxGridCellActionsPipe, MtxGridCellSummaryPipe, MtxGridColClassPipe, MtxGridColumnMenu, MtxGridExpansionToggle, MtxGridModule, MtxGridRowClassPipe, MtxGridSelectableCell, MtxGridUtils };
